window.slate = window.slate || {};
window.theme = window.theme || {};
/*================ Vendor ================*/
/*! jQuery DrawSVG v1.1.0 (2016-10-05) - git.io/vGFa5 - Copyright (c) 2016 Leonardo Santos - MIT License */
!(function (t) {
    "function" == typeof define && define.amd
        ? define(["jquery"], t)
        : "object" == typeof module && module.exports
        ? (module.exports = function (e, n) {
              return (
                  void 0 === n &&
                      (n =
                          "undefined" != typeof window
                              ? require("jquery")
                              : require("jquery")(e)),
                  t(n),
                  n
              );
          })
        : t(jQuery);
})(function (t) {
    "use strict";
    var e = "drawsvg",
        n = {
            duration: 1e3,
            stagger: 200,
            easing: "swing",
            reverse: !1,
            callback: t.noop,
        },
        a = (function () {
            var a = function (a, o) {
                var i = this,
                    r = t.extend(n, o);
                (i.$elm = t(a)),
                    i.$elm.is("svg") &&
                        ((i.options = r),
                        (i.$paths = i.$elm.find("path")),
                        (i.totalDuration =
                            r.duration + r.stagger * i.$paths.length),
                        (i.duration = r.duration / i.totalDuration),
                        i.$paths.each(function (t, e) {
                            var n = e.getTotalLength();
                            (e.pathLen = n),
                                (e.delay = (r.stagger * t) / i.totalDuration),
                                (e.style.strokeDasharray = [n, n].join(" ")),
                                (e.style.strokeDashoffset = n);
                        }),
                        i.$elm.attr("class", function (t, n) {
                            return [n, e + "-initialized"].join(" ");
                        }));
            };
            return (
                (a.prototype.getVal = function (e, n) {
                    return 1 - t.easing[n](e, e, 0, 1, 1);
                }),
                (a.prototype.progress = function (t) {
                    var e = this,
                        n = e.options,
                        a = e.duration;
                    e.$paths.each(function (o, i) {
                        var r = i.style;
                        if (1 === t) r.strokeDashoffset = 0;
                        else if (0 === t) r.strokeDashoffset = i.pathLen + "px";
                        else if (t >= i.delay && t <= a + i.delay) {
                            var s = (t - i.delay) / a;
                            r.strokeDashoffset =
                                e.getVal(s, n.easing) *
                                    i.pathLen *
                                    (n.reverse ? -1 : 1) +
                                "px";
                        }
                    });
                }),
                (a.prototype.animate = function () {
                    var n = this;
                    n.$elm.attr("class", function (t, n) {
                        return [n, e + "-animating"].join(" ");
                    }),
                        t({ len: 0 }).animate(
                            { len: 1 },
                            {
                                easing: "linear",
                                duration: n.totalDuration,
                                step: function (t, e) {
                                    n.progress.call(n, t / e.end);
                                },
                                complete: function () {
                                    n.options.callback.call(this),
                                        n.$elm.attr("class", function (t, n) {
                                            return n.replace(
                                                e + "-animating",
                                                ""
                                            );
                                        });
                                },
                            }
                        );
                }),
                a
            );
        })();
    t.fn[e] = function (n, o) {
        return this.each(function () {
            var i = t.data(this, e);
            i && "" + n === n && i[n]
                ? i[n](o)
                : t.data(this, e, new a(this, n));
        });
    };
});

/**
 * Hover balloon on elements without css and images.
 *
 * Copyright (c) 2011 Hayato Takenaka
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 * @author: Hayato Takenaka (https://urin.github.io)
 * @version: 1.1.2 - 2017/04/30
 **/
(function ($) {
    //-----------------------------------------------------------------------------
    // Private
    //-----------------------------------------------------------------------------
    // Helper for meta programming
    const Meta = {
        pos: $.extend(["top", "bottom", "left", "right"], {
            camel: ["Top", "Bottom", "Left", "Right"],
        }),
        size: $.extend(["height", "width"], { camel: ["Height", "Width"] }),
        getRelativeNames: function (position) {
            const idx = {
                pos: {
                    o: position, // origin
                    f: position % 2 === 0 ? position + 1 : position - 1, // faced
                    p1: position % 2 === 0 ? position : position - 1,
                    p2: position % 2 === 0 ? position + 1 : position,
                    c1: position < 2 ? 2 : 0,
                    c2: position < 2 ? 3 : 1,
                },
                size: {
                    p: position < 2 ? 0 : 1, // parallel
                    c: position < 2 ? 1 : 0, // cross
                },
            };
            const names = {};
            for (var m1 in idx) {
                if (!names[m1]) {
                    names[m1] = {};
                }
                for (var m2 in idx[m1]) {
                    names[m1][m2] = Meta[m1][idx[m1][m2]];
                    if (!names.camel) {
                        names.camel = {};
                    }
                    if (!names.camel[m1]) {
                        names.camel[m1] = {};
                    }
                    names.camel[m1][m2] = Meta[m1].camel[idx[m1][m2]];
                }
            }
            names.isTopLeft = names.pos.o === names.pos.p1;
            return names;
        },
    };

    // Helper class to handle position and size as numerical pixels.
    function NumericalBoxElement() {
        this.initialize.apply(this, arguments);
    }
    (function () {
        // Method factories
        const Methods = {
            setBorder: function (pos, isVertical) {
                return function (value) {
                    this.$.css(
                        "border-" + pos.toLowerCase() + "-width",
                        value + "px"
                    );
                    this["border" + pos] = value;
                    return this.isActive ? digitalize(this, isVertical) : this;
                };
            },
            setPosition: function (pos, isVertical) {
                return function (value) {
                    this.$.css(pos.toLowerCase(), value + "px");
                    this[pos.toLowerCase()] = value;
                    return this.isActive ? digitalize(this, isVertical) : this;
                };
            },
        };

        NumericalBoxElement.prototype = {
            initialize: function ($element) {
                this.$ = $element;
                $.extend(true, this, this.$.offset(), {
                    center: {},
                    inner: { center: {} },
                });
                for (var i = 0; i < Meta.pos.length; i++) {
                    this["border" + Meta.pos.camel[i]] =
                        parseInt(
                            this.$.css("border-" + Meta.pos[i] + "-width")
                        ) || 0;
                }
                this.active();
            },
            active: function () {
                this.isActive = true;
                digitalize(this);
                return this;
            },
            inactive: function () {
                this.isActive = false;
                return this;
            },
        };
        for (var i = 0; i < Meta.pos.length; i++) {
            NumericalBoxElement.prototype[
                "setBorder" + Meta.pos.camel[i]
            ] = Methods.setBorder(Meta.pos.camel[i], i < 2);
            if (i % 2 === 0) {
                NumericalBoxElement.prototype[
                    "set" + Meta.pos.camel[i]
                ] = Methods.setPosition(Meta.pos.camel[i], i < 2);
            }
        }

        function digitalize(box, isVertical) {
            if (isVertical == null) {
                digitalize(box, true);
                return digitalize(box, false);
            }
            const m = Meta.getRelativeNames(isVertical ? 0 : 2);
            box[m.size.p] = box.$["outer" + m.camel.size.p]();
            box[m.pos.f] = box[m.pos.o] + box[m.size.p];
            box.center[m.pos.o] = box[m.pos.o] + box[m.size.p] / 2;
            box.inner[m.pos.o] = box[m.pos.o] + box["border" + m.camel.pos.o];
            box.inner[m.size.p] = box.$["inner" + m.camel.size.p]();
            box.inner[m.pos.f] = box.inner[m.pos.o] + box.inner[m.size.p];
            box.inner.center[m.pos.o] =
                box.inner[m.pos.f] + box.inner[m.size.p] / 2;
            return box;
        }
    })();

    // Adjust position of balloon body
    function makeupBalloon($target, $balloon, options) {
        $balloon.stop(true, true);
        var outerTip, innerTip;
        const initTipStyle = {
                position: "absolute",
                height: "0",
                width: "0",
                border: "solid 0 transparent",
            },
            target = new NumericalBoxElement($target),
            balloon = new NumericalBoxElement($balloon);
        const balloonTop =
            -options.offsetY +
            (options.position && options.position.indexOf("top") >= 0
                ? target.top - balloon.height
                : options.position && options.position.indexOf("bottom") >= 0
                ? target.bottom
                : target.center.top - balloon.height / 2);
        const balloonLeft =
            options.offsetX +
            (options.position && options.position.indexOf("left") >= 0
                ? target.left - balloon.width
                : options.position && options.position.indexOf("right") >= 0
                ? target.right
                : target.center.left - balloon.width / 2);
        balloon.setTop(balloonTop < 0 ? 0 : balloonTop);
        balloon.setLeft(balloonLeft < 0 ? 0 : balloonLeft);
        if (options.tipSize > 0) {
            // Add hidden balloon tips into balloon body.
            if ($balloon.data("outerTip")) {
                $balloon.data("outerTip").remove();
                $balloon.removeData("outerTip");
            }
            if ($balloon.data("innerTip")) {
                $balloon.data("innerTip").remove();
                $balloon.removeData("innerTip");
            }
            outerTip = new NumericalBoxElement(
                $("<div>").css(initTipStyle).appendTo($balloon)
            );
            innerTip = new NumericalBoxElement(
                $("<div>").css(initTipStyle).appendTo($balloon)
            );
            // Make tip triangle, adjust position of tips.
            var m;
            for (var i = 0; i < Meta.pos.length; i++) {
                m = Meta.getRelativeNames(i);
                if (
                    balloon.center[m.pos.c1] >= target[m.pos.c1] &&
                    balloon.center[m.pos.c1] <= target[m.pos.c2]
                ) {
                    if (i % 2 === 0) {
                        if (
                            balloon[m.pos.o] >= target[m.pos.o] &&
                            balloon[m.pos.f] >= target[m.pos.f]
                        ) {
                            break;
                        }
                    } else {
                        if (
                            balloon[m.pos.o] <= target[m.pos.o] &&
                            balloon[m.pos.f] <= target[m.pos.f]
                        ) {
                            break;
                        }
                    }
                }
                m = null;
            }
            if (m) {
                balloon["set" + m.camel.pos.p1](
                    balloon[m.pos.p1] +
                        (m.isTopLeft ? 1 : -1) *
                            (options.tipSize -
                                balloon["border" + m.camel.pos.o])
                );
                makeTip(
                    balloon,
                    outerTip,
                    m,
                    options.tipSize,
                    $balloon.css("border-" + m.pos.o + "-color"),
                    options.tipPosition
                );
                makeTip(
                    balloon,
                    innerTip,
                    m,
                    options.tipSize - 2 * balloon["border" + m.camel.pos.o],
                    $balloon.css("background-color"),
                    options.tipPosition
                );
                $balloon
                    .data("outerTip", outerTip.$)
                    .data("innerTip", innerTip.$);
            } else {
                $.each([outerTip.$, innerTip.$], function () {
                    this.remove();
                });
            }
        }
        // Make up balloon tip.
        function makeTip(balloon, tip, m, tipSize, color, pos) {
            const len = Math.round(tipSize / 1.7320508);
            tip.inactive()
                ["setBorder" + m.camel.pos.f](tipSize)
                ["setBorder" + m.camel.pos.c1](len)
                ["setBorder" + m.camel.pos.c2](len)
                ["set" + m.camel.pos.p1](
                    m.isTopLeft ? -tipSize : balloon.inner[m.size.p]
                )
                ["set" + m.camel.pos.c1](balloon.inner[m.size.c] / pos - len)
                .active()
                .$.css("border-" + m.pos.f + "-color", color);
        }
    }

    // True if the event comes from the target or balloon.
    function isValidTargetEvent($target, e) {
        const b = $target.data("balloon") && $target.data("balloon").get(0);
        return !(
            b &&
            (b === e.relatedTarget || $.contains(b, e.relatedTarget))
        );
    }

    // Assign plain text or HTML to the balloon's body
    function assignContents($balloon, options, contents) {
        if (options.html) {
            $balloon.empty().append(contents);
        } else {
            $balloon.text(contents);
        }
    }

    // Actions common to the `options.url` and `options.ajax`
    // callbacks on successful completion of the AJAX request
    function onAjaxContents($target, $balloon, options) {
        $balloon.data("ajaxDisabled", true);
        if (options.ajaxContentsMaxAge >= 0) {
            setTimeout(function () {
                $balloon.data("ajaxDisabled", false);
            }, options.ajaxContentsMaxAge);
        }
        makeupBalloon($target, $balloon, options);
    }

    //-----------------------------------------------------------------------------
    // Public
    //-----------------------------------------------------------------------------
    $.fn.balloon = function (options) {
        return this.one("mouseenter", function first(e) {
            const $target = $(this),
                t = this;
            const $balloon = $target
                .on("mouseenter", function (e) {
                    isValidTargetEvent($target, e) && $target.showBalloon();
                })
                .off("mouseenter", first)
                .showBalloon(options)
                .data("balloon");
            if ($balloon) {
                $balloon
                    .on("mouseleave", function (e) {
                        if (
                            t === e.relatedTarget ||
                            $.contains(t, e.relatedTarget)
                        ) {
                            return;
                        }
                        $target.hideBalloon();
                    })
                    .on("mouseenter", function (e) {
                        if (
                            t === e.relatedTarget ||
                            $.contains(t, e.relatedTarget)
                        ) {
                            return;
                        }
                        $balloon.stop(true, true);
                        $target.showBalloon();
                    });
            }
        }).on("mouseleave", function (e) {
            const $target = $(this);
            isValidTargetEvent($target, e) && $target.hideBalloon();
        });
    };

    $.fn.showBalloon = function (options) {
        var optionsOld = this.data("options")
            ? this.data("options")
            : options || {};
        if (options || !this.data("options")) {
            if ($.balloon.defaults.css === null) {
                $.balloon.defaults.css = {};
            }
            this.data(
                "options",
                $.extend(true, {}, $.balloon.defaults, options || {})
            );
        }
        options = this.data("options");
        return this.each(function () {
            var target = this,
                $target = $(target);
            var isNew = !$target.data("balloon");
            var $balloon = $target.data("balloon") || $("<div>");
            if (!isNew && $balloon.data("active")) {
                return;
            }
            $balloon.data("active", true);
            clearTimeout($balloon.data("minLifetime"));
            const contents = $.isFunction(options.contents)
                ? options.contents.call(target)
                : options.contents ||
                  $target.attr("title") ||
                  $target.attr("alt");
            $target.removeAttr("title");
            var ajax = $.isFunction(options.ajax) || options.url;
            if ((!ajax && contents === "") || contents == null) {
                return;
            }
            if (!$.isFunction(options.contents)) {
                options.contents = contents;
            }
            if (!ajax) {
                assignContents($balloon, options, contents);
            } else if (!$balloon.data("ajaxDisabled")) {
                if (contents !== "" && contents != null) {
                    assignContents($balloon, options, contents);
                }
                clearTimeout($balloon.data("ajaxDelay"));
                if (options.url) {
                    ajax = function () {
                        $balloon.load(
                            $.isFunction(options.url)
                                ? options.url.call(target)
                                : options.url,
                            function (res, sts, xhr) {
                                if (options.ajaxComplete) {
                                    options.ajaxComplete.call(
                                        target,
                                        res,
                                        sts,
                                        xhr
                                    );
                                }
                                if (
                                    sts === "success" ||
                                    sts === "notmodified"
                                ) {
                                    onAjaxContents($target, $balloon, options);
                                }
                            }
                        );
                    };
                } else {
                    ajax = function () {
                        var called = false;
                        function done(error, contents) {
                            if (!called) {
                                called = true;
                                if (error) {
                                    return;
                                }
                                assignContents($balloon, options, contents);
                                onAjaxContents($target, $balloon, options);
                            }
                        }
                        const promise = options.ajax.call(target, done);
                        if (promise && $.isFunction(promise.then)) {
                            promise.then(
                                function (contents) {
                                    done(null, contents);
                                },
                                function (error) {
                                    done(error);
                                }
                            );
                        }
                    };
                }
                $balloon.data("ajaxDelay", setTimeout(ajax, options.ajaxDelay));
            }

            $balloon
                .css(options.css || {})
                .removeClass(optionsOld.classname)
                .addClass(options.classname);
            if (isNew) {
                $balloon
                    .css({ visibility: "hidden", position: "absolute" })
                    .appendTo("body");
                $target.data("balloon", $balloon);
                makeupBalloon($target, $balloon, options);
                $balloon.hide().css("visibility", "visible");
            } else {
                makeupBalloon($target, $balloon, options);
            }
            $balloon.data(
                "delay",
                setTimeout(function () {
                    if (options.showAnimation) {
                        options.showAnimation.apply($balloon.stop(true, true), [
                            options.showDuration,
                            function () {
                                options.showComplete &&
                                    options.showComplete.apply($balloon);
                            },
                        ]);
                    } else {
                        $balloon.show(options.showDuration, function () {
                            if (this.style.removeAttribute) {
                                this.style.removeAttribute("filter");
                            }
                            options.showComplete &&
                                options.showComplete.apply($balloon);
                        });
                    }
                    if (options.maxLifetime) {
                        clearTimeout($balloon.data("maxLifetime"));
                        $balloon.data(
                            "maxLifetime",
                            setTimeout(function () {
                                $target.hideBalloon();
                            }, options.maxLifetime)
                        );
                    }
                }, options.delay)
            );
        });
    };

    $.fn.hideBalloon = function () {
        const options = this.data("options");
        if (!this.data("balloon")) {
            return this;
        }
        return this.each(function () {
            const $target = $(this),
                $balloon = $target.data("balloon");
            clearTimeout($balloon.data("delay"));
            clearTimeout($balloon.data("minLifetime"));
            clearTimeout($balloon.data("ajaxDelay"));
            $balloon.data(
                "minLifetime",
                setTimeout(function () {
                    if (options.hideAnimation) {
                        options.hideAnimation.apply($balloon.stop(true, true), [
                            options.hideDuration,
                            function (d) {
                                $(this).data("active", false);
                                options.hideComplete && options.hideComplete(d);
                            },
                        ]);
                    } else {
                        $balloon
                            .stop(true, true)
                            .hide(options.hideDuration, function (d) {
                                $(this).data("active", false);
                                options.hideComplete && options.hideComplete(d);
                            });
                    }
                }, options.minLifetime)
            );
        });
    };

    $.balloon = {
        defaults: {
            contents: null,
            html: false,
            classname: null,
            url: null,
            ajax: null,
            ajaxComplete: null,
            ajaxDelay: 500,
            ajaxContentsMaxAge: -1,
            delay: 0,
            minLifetime: 200,
            maxLifetime: 0,
            position: "top",
            offsetX: 0,
            offsetY: 0,
            tipSize: 8,
            tipPosition: 2,
            showDuration: 100,
            showAnimation: null,
            hideDuration: 80,
            hideAnimation: function (d, c) {
                this.fadeOut(d, c);
            },
            showComplete: null,
            hideComplete: null,
            css: {
                fontSize: ".7rem",
                minWidth: ".7rem",
                padding: ".2rem .5rem",
                border: "1px solid rgba(212, 212, 212, .4)",
                borderRadius: "3px",
                boxShadow: "2px 2px 4px #555",
                color: "#eee",
                backgroundColor: "#111",
                opacity: 0.85,
                zIndex: "32767",
                textAlign: "left",
            },
        },
    };
})(jQuery);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function (window, document, undefined) {
    // Enable strict mode
    "use strict";

    // HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
    document.createElement("picture");

    var warn, eminpx, alwaysCheckWDescriptor, evalId;
    // local object for method references and testing exposure
    var pf = {};
    var isSupportTestReady = false;
    var noop = function () {};
    var image = document.createElement("img");
    var getImgAttr = image.getAttribute;
    var setImgAttr = image.setAttribute;
    var removeImgAttr = image.removeAttribute;
    var docElem = document.documentElement;
    var types = {};
    var cfg = {
        //resource selection:
        algorithm: "",
    };
    var srcAttr = "data-pfsrc";
    var srcsetAttr = srcAttr + "set";
    // ua sniffing is done for undetectable img loading features,
    // to do some non crucial perf optimizations
    var ua = navigator.userAgent;
    var supportAbort =
        /rident/.test(ua) ||
        (/ecko/.test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35);
    var curSrcProp = "currentSrc";
    var regWDesc = /\s+\+?\d+(e\d+)?w/;
    var regSize = /(\([^)]+\))?\s*(.+)/;
    var setOptions = window.picturefillCFG;
    /**
     * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
     */
    // baseStyle also used by getEmValue (i.e.: width: 1em is important)
    var baseStyle =
        "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
    var fsCss = "font-size:100%!important;";
    var isVwDirty = true;

    var cssCache = {};
    var sizeLengthCache = {};
    var DPR = window.devicePixelRatio;
    var units = {
        px: 1,
        in: 96,
    };
    var anchor = document.createElement("a");
    /**
     * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
     * @type {boolean}
     */
    var alreadyRun = false;

    // Reusable, non-"g" Regexes

    // (Don't use \s, to avoid matching non-breaking space.)
    var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
        regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
        regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
        regexTrailingCommas = /[,]+$/,
        regexNonNegativeInteger = /^\d+$/,
        // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

    var on = function (obj, evt, fn, capture) {
        if (obj.addEventListener) {
            obj.addEventListener(evt, fn, capture || false);
        } else if (obj.attachEvent) {
            obj.attachEvent("on" + evt, fn);
        }
    };

    /**
     * simple memoize function:
     */

    var memoize = function (fn) {
        var cache = {};
        return function (input) {
            if (!(input in cache)) {
                cache[input] = fn(input);
            }
            return cache[input];
        };
    };

    // UTILITY FUNCTIONS

    // Manual is faster than RegEx
    // http://jsperf.com/whitespace-character/5
    function isSpace(c) {
        return (
            c === "\u0020" || // space
            c === "\u0009" || // horizontal tab
            c === "\u000A" || // new line
            c === "\u000C" || // form feed
            c === "\u000D"
        ); // carriage return
    }

    /**
     * gets a mediaquery and returns a boolean or gets a css length and returns a number
     * @param css mediaqueries or css length
     * @returns {boolean|number}
     *
     * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
     */
    var evalCSS = (function () {
        var regLength = /^([\d\.]+)(em|vw|px)$/;
        var replace = function () {
            var args = arguments,
                index = 0,
                string = args[0];
            while (++index in args) {
                string = string.replace(args[index], args[++index]);
            }
            return string;
        };

        var buildStr = memoize(function (css) {
            return (
                "return " +
                replace(
                    (css || "").toLowerCase(),
                    // interpret `and`
                    /\band\b/g,
                    "&&",

                    // interpret `,`
                    /,/g,
                    "||",

                    // interpret `min-` as >=
                    /min-([a-z-\s]+):/g,
                    "e.$1>=",

                    // interpret `max-` as <=
                    /max-([a-z-\s]+):/g,
                    "e.$1<=",

                    //calc value
                    /calc([^)]+)/g,
                    "($1)",

                    // interpret css values
                    /(\d+[\.]*[\d]*)([a-z]+)/g,
                    "($1 * e.$2)",
                    //make eval less evil
                    /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,
                    ""
                ) +
                ";"
            );
        });

        return function (css, length) {
            var parsedLength;
            if (!(css in cssCache)) {
                cssCache[css] = false;
                if (length && (parsedLength = css.match(regLength))) {
                    cssCache[css] = parsedLength[1] * units[parsedLength[2]];
                } else {
                    /*jshint evil:true */
                    try {
                        cssCache[css] = new Function("e", buildStr(css))(units);
                    } catch (e) {}
                    /*jshint evil:false */
                }
            }
            return cssCache[css];
        };
    })();

    var setResolution = function (candidate, sizesattr) {
        if (candidate.w) {
            // h = means height: || descriptor.type === 'h' do not handle yet...
            candidate.cWidth = pf.calcListLength(sizesattr || "100vw");
            candidate.res = candidate.w / candidate.cWidth;
        } else {
            candidate.res = candidate.d;
        }
        return candidate;
    };

    /**
     *
     * @param opt
     */
    var picturefill = function (opt) {
        if (!isSupportTestReady) {
            return;
        }

        var elements, i, plen;

        var options = opt || {};

        if (options.elements && options.elements.nodeType === 1) {
            if (options.elements.nodeName.toUpperCase() === "IMG") {
                options.elements = [options.elements];
            } else {
                options.context = options.elements;
                options.elements = null;
            }
        }

        elements =
            options.elements ||
            pf.qsa(
                options.context || document,
                options.reevaluate || options.reselect ? pf.sel : pf.selShort
            );

        if ((plen = elements.length)) {
            pf.setupRun(options);
            alreadyRun = true;

            // Loop through all elements
            for (i = 0; i < plen; i++) {
                pf.fillImg(elements[i], options);
            }

            pf.teardownRun(options);
        }
    };

    /**
     * outputs a warning for the developer
     * @param {message}
     * @type {Function}
     */
    warn =
        window.console && console.warn
            ? function (message) {
                  console.warn(message);
              }
            : noop;

    if (!(curSrcProp in image)) {
        curSrcProp = "src";
    }

    // Add support for standard mime types.
    types["image/jpeg"] = true;
    types["image/gif"] = true;
    types["image/png"] = true;

    function detectTypeSupport(type, typeUri) {
        // based on Modernizr's lossless img-webp test
        // note: asynchronous
        var image = new window.Image();
        image.onerror = function () {
            types[type] = false;
            picturefill();
        };
        image.onload = function () {
            types[type] = image.width === 1;
            picturefill();
        };
        image.src = typeUri;
        return "pending";
    }

    // test svg support
    types["image/svg+xml"] = document.implementation.hasFeature(
        "http://www.w3.org/TR/SVG11/feature#Image",
        "1.1"
    );

    /**
     * updates the internal vW property with the current viewport width in px
     */
    function updateMetrics() {
        isVwDirty = false;
        DPR = window.devicePixelRatio;
        cssCache = {};
        sizeLengthCache = {};

        pf.DPR = DPR || 1;

        units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
        units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

        units.vw = units.width / 100;
        units.vh = units.height / 100;

        evalId = [units.height, units.width, DPR].join("-");

        units.em = pf.getEmValue();
        units.rem = units.em;
    }

    function chooseLowRes(lowerValue, higherValue, dprValue, isCached) {
        var bonusFactor, tooMuch, bonus, meanDensity;

        //experimental
        if (cfg.algorithm === "saveData") {
            if (lowerValue > 2.7) {
                meanDensity = dprValue + 1;
            } else {
                tooMuch = higherValue - dprValue;
                bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

                bonus = tooMuch * bonusFactor;

                if (isCached) {
                    bonus += 0.1 * bonusFactor;
                }

                meanDensity = lowerValue + bonus;
            }
        } else {
            meanDensity =
                dprValue > 1 ? Math.sqrt(lowerValue * higherValue) : lowerValue;
        }

        return meanDensity > dprValue;
    }

    function applyBestCandidate(img) {
        var srcSetCandidates;
        var matchingSet = pf.getSet(img);
        var evaluated = false;
        if (matchingSet !== "pending") {
            evaluated = evalId;
            if (matchingSet) {
                srcSetCandidates = pf.setRes(matchingSet);
                pf.applySetCandidate(srcSetCandidates, img);
            }
        }
        img[pf.ns].evaled = evaluated;
    }

    function ascendingSort(a, b) {
        return a.res - b.res;
    }

    function setSrcToCur(img, src, set) {
        var candidate;
        if (!set && src) {
            set = img[pf.ns].sets;
            set = set && set[set.length - 1];
        }

        candidate = getCandidateForSrc(src, set);

        if (candidate) {
            src = pf.makeUrl(src);
            img[pf.ns].curSrc = src;
            img[pf.ns].curCan = candidate;

            if (!candidate.res) {
                setResolution(candidate, candidate.set.sizes);
            }
        }
        return candidate;
    }

    function getCandidateForSrc(src, set) {
        var i, candidate, candidates;
        if (src && set) {
            candidates = pf.parseSet(set);
            src = pf.makeUrl(src);
            for (i = 0; i < candidates.length; i++) {
                if (src === pf.makeUrl(candidates[i].url)) {
                    candidate = candidates[i];
                    break;
                }
            }
        }
        return candidate;
    }

    function getAllSourceElements(picture, candidates) {
        var i, len, source, srcset;

        // SPEC mismatch intended for size and perf:
        // actually only source elements preceding the img should be used
        // also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
        var sources = picture.getElementsByTagName("source");

        for (i = 0, len = sources.length; i < len; i++) {
            source = sources[i];
            source[pf.ns] = true;
            srcset = source.getAttribute("srcset");

            // if source does not have a srcset attribute, skip
            if (srcset) {
                candidates.push({
                    srcset: srcset,
                    media: source.getAttribute("media"),
                    type: source.getAttribute("type"),
                    sizes: source.getAttribute("sizes"),
                });
            }
        }
    }

    /**
     * Srcset Parser
     * By Alex Bell |  MIT License
     *
     * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
     *
     * Based super duper closely on the reference algorithm at:
     * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
     */

    // 1. Let input be the value passed to this algorithm.
    // (TO-DO : Explain what "set" argument is here. Maybe choose a more
    // descriptive & more searchable name.  Since passing the "set" in really has
    // nothing to do with parsing proper, I would prefer this assignment eventually
    // go in an external fn.)
    function parseSrcset(input, set) {
        function collectCharacters(regEx) {
            var chars,
                match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }

        var inputLength = input.length,
            url,
            descriptors,
            currentDescriptor,
            state,
            c,
            // 2. Let position be a pointer into input, initially pointing at the start
            //    of the string.
            pos = 0,
            // 3. Let candidates be an initially empty source set.
            candidates = [];

        /**
         * Adds descriptor properties to a candidate, pushes to the candidates array
         * @return undefined
         */
        // (Declared outside of the while loop so that it's only created once.
        // (This fn is defined before it is used, in order to pass JSHINT.
        // Unfortunately this breaks the sequencing of the spec comments. :/ )
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false,
                // 10. Let width be absent.
                // 11. Let density be absent.
                // 12. Let future-compat-h be absent. (We're implementing it now as h)
                w,
                d,
                h,
                i,
                candidate = {},
                desc,
                lastChar,
                value,
                intVal,
                floatVal;

            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for (i = 0; i < descriptors.length; i++) {
                desc = descriptors[i];

                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);

                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) {
                        pError = true;
                    }

                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) {
                        pError = true;
                    } else {
                        w = intVal;
                    }

                    // If the descriptor consists of a valid floating-point number followed by
                    // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) {
                        pError = true;
                    }

                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) {
                        pError = true;
                    } else {
                        d = floatVal;
                    }

                    // If the descriptor consists of a valid non-negative integer followed by
                    // a U+0068 LATIN SMALL LETTER H character
                } else if (
                    regexNonNegativeInteger.test(value) &&
                    lastChar === "h"
                ) {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) {
                        pError = true;
                    }

                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) {
                        pError = true;
                    } else {
                        h = intVal;
                    }

                    // Anything else, Let error be yes.
                } else {
                    pError = true;
                }
            } // (close step 13 for loop)

            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;

                if (w) {
                    candidate.w = w;
                }
                if (d) {
                    candidate.d = d;
                }
                if (h) {
                    candidate.h = h;
                }
                if (!h && !d && !w) {
                    candidate.d = 1;
                }
                if (candidate.d === 1) {
                    set.has1x = true;
                }
                candidate.set = set;

                candidates.push(candidate);
            }
        } // (close parseDescriptors fn)

        /**
         * Tokenizes descriptor properties prior to parsing
         * Returns undefined.
         * (Again, this fn is defined before it is used, in order to pass JSHINT.
         * Unfortunately this breaks the logical sequencing of the spec comments. :/ )
         */
        function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);

            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";

            // 8.3. Let state be in descriptor.
            state = "in descriptor";

            while (true) {
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);

                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.

                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:

                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }

                        // U+002C COMMA (,)
                        // Advance position to the next character in input. If current descriptor
                        // is not empty, append current descriptor to descriptors. Jump to the step
                        // labeled descriptor parser.
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                        }
                        parseDescriptors();
                        return;

                        // U+0028 LEFT PARENTHESIS (()
                        // Append c to current descriptor. Set state to in parens.
                    } else if (c === "\u0028") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";

                        // EOF
                        // If current descriptor is not empty, append current descriptor to
                        // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                        }
                        parseDescriptors();
                        return;

                        // Anything else
                        // Append c to current descriptor.
                    } else {
                        currentDescriptor = currentDescriptor + c;
                    }
                    // (end "in descriptor"

                    // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";

                        // EOF
                        // Append current descriptor to descriptors. Jump to the step labeled
                        // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;

                        // Anything else
                        // Append c to current descriptor.
                    } else {
                        currentDescriptor = currentDescriptor + c;
                    }

                    // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) {
                        // EOF: Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        parseDescriptors();
                        return;

                        // Anything else
                        // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }

                // Advance position to the next character in input.
                pos += 1;

                // Repeat this step.
            } // (close while true loop)
        }

        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while (true) {
            collectCharacters(regexLeadingCommasOrSpaces);

            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) {
                return candidates; // (we're done, this is the sole return path)
            }

            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);

            // 7. Let descriptors be a new empty list.
            descriptors = [];

            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();

                //	Otherwise, follow these substeps:
            } else {
                tokenize();
            } // (close else of step 8)

            // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
    }

    /*
     * Sizes Parser
     *
     * By Alex Bell |  MIT License
     *
     * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
     *
     * Reference algorithm at:
     * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
     *
     * Most comments are copied in directly from the spec
     * (except for comments in parens).
     *
     * Grammar is:
     * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
     * <source-size> = <media-condition> <source-size-value>
     * <source-size-value> = <length>
     * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
     *
     * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
     * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
     *
     * Returns the first valid <css-length> with a media condition that evaluates to true,
     * or "100vw" if all valid media conditions evaluate to false.
     *
     */

    function parseSizes(strValue) {
        // (Percentage CSS lengths are not allowed in this case, to avoid confusion:
        // https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
        // CSS allows a single optional plus or minus sign:
        // http://www.w3.org/TR/CSS2/syndata.html#numbers
        // CSS is ASCII case-insensitive:
        // http://www.w3.org/TR/CSS2/syndata.html#characters )
        // Spec allows exponential notation for <number> type:
        // http://dev.w3.org/csswg/css-values/#numbers
        var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

        // (This is a quick and lenient test. Because of optional unlimited-depth internal
        // grouping parens and strict spacing rules, this could get very complicated.)
        var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

        var i;
        var unparsedSizesList;
        var unparsedSizesListLength;
        var unparsedSize;
        var lastComponentValue;
        var size;

        // UTILITY FUNCTIONS

        //  (Toy CSS parser. The goals here are:
        //  1) expansive test coverage without the weight of a full CSS parser.
        //  2) Avoiding regex wherever convenient.
        //  Quick tests: http://jsfiddle.net/gtntL4gr/3/
        //  Returns an array of arrays.)
        function parseComponentValues(str) {
            var chrctr;
            var component = "";
            var componentArray = [];
            var listArray = [];
            var parenDepth = 0;
            var pos = 0;
            var inComment = false;

            function pushComponent() {
                if (component) {
                    componentArray.push(component);
                    component = "";
                }
            }

            function pushComponentArray() {
                if (componentArray[0]) {
                    listArray.push(componentArray);
                    componentArray = [];
                }
            }

            // (Loop forwards from the beginning of the string.)
            while (true) {
                chrctr = str.charAt(pos);

                if (chrctr === "") {
                    // ( End of string reached.)
                    pushComponent();
                    pushComponentArray();
                    return listArray;
                } else if (inComment) {
                    if (chrctr === "*" && str[pos + 1] === "/") {
                        // (At end of a comment.)
                        inComment = false;
                        pos += 2;
                        pushComponent();
                        continue;
                    } else {
                        pos += 1; // (Skip all characters inside comments.)
                        continue;
                    }
                } else if (isSpace(chrctr)) {
                    // (If previous character in loop was also a space, or if
                    // at the beginning of the string, do not add space char to
                    // component.)
                    if (
                        (str.charAt(pos - 1) && isSpace(str.charAt(pos - 1))) ||
                        !component
                    ) {
                        pos += 1;
                        continue;
                    } else if (parenDepth === 0) {
                        pushComponent();
                        pos += 1;
                        continue;
                    } else {
                        // (Replace any space character with a plain space for legibility.)
                        chrctr = " ";
                    }
                } else if (chrctr === "(") {
                    parenDepth += 1;
                } else if (chrctr === ")") {
                    parenDepth -= 1;
                } else if (chrctr === ",") {
                    pushComponent();
                    pushComponentArray();
                    pos += 1;
                    continue;
                } else if (chrctr === "/" && str.charAt(pos + 1) === "*") {
                    inComment = true;
                    pos += 2;
                    continue;
                }

                component = component + chrctr;
                pos += 1;
            }
        }

        function isValidNonNegativeSourceSizeValue(s) {
            if (regexCssLengthWithUnits.test(s) && parseFloat(s) >= 0) {
                return true;
            }
            if (regexCssCalc.test(s)) {
                return true;
            }
            // ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
            // "-0 is equivalent to 0 and is not a negative number." which means that
            // unitless zero and unitless negative zero must be accepted as special cases.)
            if (s === "0" || s === "-0" || s === "+0") {
                return true;
            }
            return false;
        }

        // When asked to parse a sizes attribute from an element, parse a
        // comma-separated list of component values from the value of the element's
        // sizes attribute (or the empty string, if the attribute is absent), and let
        // unparsed sizes list be the result.
        // http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

        unparsedSizesList = parseComponentValues(strValue);
        unparsedSizesListLength = unparsedSizesList.length;

        // For each unparsed size in unparsed sizes list:
        for (i = 0; i < unparsedSizesListLength; i++) {
            unparsedSize = unparsedSizesList[i];

            // 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
            // ( parseComponentValues() already omits spaces outside of parens. )

            // If unparsed size is now empty, that is a parse error; continue to the next
            // iteration of this algorithm.
            // ( parseComponentValues() won't push an empty array. )

            // 2. If the last component value in unparsed size is a valid non-negative
            // <source-size-value>, let size be its value and remove the component value
            // from unparsed size. Any CSS function other than the calc() function is
            // invalid. Otherwise, there is a parse error; continue to the next iteration
            // of this algorithm.
            // http://dev.w3.org/csswg/css-syntax/#parse-component-value
            lastComponentValue = unparsedSize[unparsedSize.length - 1];

            if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
                size = lastComponentValue;
                unparsedSize.pop();
            } else {
                continue;
            }

            // 3. Remove all consecutive <whitespace-token>s from the end of unparsed
            // size. If unparsed size is now empty, return size and exit this algorithm.
            // If this was not the last item in unparsed sizes list, that is a parse error.
            if (unparsedSize.length === 0) {
                return size;
            }

            // 4. Parse the remaining component values in unparsed size as a
            // <media-condition>. If it does not parse correctly, or it does parse
            // correctly but the <media-condition> evaluates to false, continue to the
            // next iteration of this algorithm.
            // (Parsing all possible compound media conditions in JS is heavy, complicated,
            // and the payoff is unclear. Is there ever an situation where the
            // media condition parses incorrectly but still somehow evaluates to true?
            // Can we just rely on the browser/polyfill to do it?)
            unparsedSize = unparsedSize.join(" ");
            if (!pf.matchesMedia(unparsedSize)) {
                continue;
            }

            // 5. Return size and exit this algorithm.
            return size;
        }

        // If the above algorithm exhausts unparsed sizes list without returning a
        // size value, return 100vw.
        return "100vw";
    }

    // namespace
    pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

    // srcset support test
    pf.supSrcset = "srcset" in image;
    pf.supSizes = "sizes" in image;
    pf.supPicture = !!window.HTMLPictureElement;

    // UC browser does claim to support srcset and picture, but not sizes,
    // this extended test reveals the browser does support nothing
    if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
        (function (image2) {
            image.srcset = "data:,a";
            image2.src = "data:,a";
            pf.supSrcset = image.complete === image2.complete;
            pf.supPicture = pf.supSrcset && pf.supPicture;
        })(document.createElement("img"));
    }

    // Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
    if (pf.supSrcset && !pf.supSizes) {
        (function () {
            var width2 =
                "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
            var width1 =
                "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            var img = document.createElement("img");
            var test = function () {
                var width = img.width;

                if (width === 2) {
                    pf.supSizes = true;
                }

                alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

                isSupportTestReady = true;
                // force async
                setTimeout(picturefill);
            };

            img.onload = test;
            img.onerror = test;
            img.setAttribute("sizes", "9px");

            img.srcset = width1 + " 1w," + width2 + " 9w";
            img.src = width1;
        })();
    } else {
        isSupportTestReady = true;
    }

    // using pf.qsa instead of dom traversing does scale much better,
    // especially on sites mixing responsive and non-responsive images
    pf.selShort = "picture>img,img[srcset]";
    pf.sel = pf.selShort;
    pf.cfg = cfg;

    /**
     * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
     */
    pf.DPR = DPR || 1;
    pf.u = units;

    // container of supported mime types that one might need to qualify before using
    pf.types = types;

    pf.setSize = noop;

    /**
     * Gets a string and returns the absolute URL
     * @param src
     * @returns {String} absolute URL
     */

    pf.makeUrl = memoize(function (src) {
        anchor.href = src;
        return anchor.href;
    });

    /**
     * Gets a DOM element or document and a selctor and returns the found matches
     * Can be extended with jQuery/Sizzle for IE7 support
     * @param context
     * @param sel
     * @returns {NodeList|Array}
     */
    pf.qsa = function (context, sel) {
        return "querySelector" in context ? context.querySelectorAll(sel) : [];
    };

    /**
     * Shortcut method for matchMedia ( for easy overriding in tests )
     * wether native or pf.mMQ is used will be decided lazy on first call
     * @returns {boolean}
     */
    pf.matchesMedia = function () {
        if (
            window.matchMedia &&
            (matchMedia("(min-width: 0.1em)") || {}).matches
        ) {
            pf.matchesMedia = function (media) {
                return !media || matchMedia(media).matches;
            };
        } else {
            pf.matchesMedia = pf.mMQ;
        }

        return pf.matchesMedia.apply(this, arguments);
    };

    /**
     * A simplified matchMedia implementation for IE8 and IE9
     * handles only min-width/max-width with px or em values
     * @param media
     * @returns {boolean}
     */
    pf.mMQ = function (media) {
        return media ? evalCSS(media) : true;
    };

    /**
     * Returns the calculated length in css pixel from the given sourceSizeValue
     * http://dev.w3.org/csswg/css-values-3/#length-value
     * intended Spec mismatches:
     * * Does not check for invalid use of CSS functions
     * * Does handle a computed length of 0 the same as a negative and therefore invalid value
     * @param sourceSizeValue
     * @returns {Number}
     */
    pf.calcLength = function (sourceSizeValue) {
        var value = evalCSS(sourceSizeValue, true) || false;
        if (value < 0) {
            value = false;
        }

        return value;
    };

    /**
     * Takes a type string and checks if its supported
     */

    pf.supportsType = function (type) {
        return type ? types[type] : true;
    };

    /**
     * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
     * @param sourceSizeStr
     * @returns {*}
     */
    pf.parseSize = memoize(function (sourceSizeStr) {
        var match = (sourceSizeStr || "").match(regSize);
        return {
            media: match && match[1],
            length: match && match[2],
        };
    });

    pf.parseSet = function (set) {
        if (!set.cands) {
            set.cands = parseSrcset(set.srcset, set);
        }
        return set.cands;
    };

    /**
     * returns 1em in css px for html/body default size
     * function taken from respondjs
     * @returns {*|number}
     */
    pf.getEmValue = function () {
        var body;
        if (!eminpx && (body = document.body)) {
            var div = document.createElement("div"),
                originalHTMLCSS = docElem.style.cssText,
                originalBodyCSS = body.style.cssText;

            div.style.cssText = baseStyle;

            // 1em in a media query is the value of the default font size of the browser
            // reset docElem and body to ensure the correct value is returned
            docElem.style.cssText = fsCss;
            body.style.cssText = fsCss;

            body.appendChild(div);
            eminpx = div.offsetWidth;
            body.removeChild(div);

            //also update eminpx before returning
            eminpx = parseFloat(eminpx, 10);

            // restore the original values
            docElem.style.cssText = originalHTMLCSS;
            body.style.cssText = originalBodyCSS;
        }
        return eminpx || 16;
    };

    /**
     * Takes a string of sizes and returns the width in pixels as a number
     */
    pf.calcListLength = function (sourceSizeListStr) {
        // Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
        //
        //                           or (min-width:30em) calc(30% - 15px)
        if (!(sourceSizeListStr in sizeLengthCache) || cfg.uT) {
            var winningLength = pf.calcLength(parseSizes(sourceSizeListStr));

            sizeLengthCache[sourceSizeListStr] = !winningLength
                ? units.width
                : winningLength;
        }

        return sizeLengthCache[sourceSizeListStr];
    };

    /**
     * Takes a candidate object with a srcset property in the form of url/
     * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
     *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
     *     "images/pic-small.png"
     * Get an array of image candidates in the form of
     *      {url: "/foo/bar.png", resolution: 1}
     * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
     * If sizes is specified, res is calculated
     */
    pf.setRes = function (set) {
        var candidates;
        if (set) {
            candidates = pf.parseSet(set);

            for (var i = 0, len = candidates.length; i < len; i++) {
                setResolution(candidates[i], set.sizes);
            }
        }
        return candidates;
    };

    pf.setRes.res = setResolution;

    pf.applySetCandidate = function (candidates, img) {
        if (!candidates.length) {
            return;
        }
        var candidate,
            i,
            j,
            length,
            bestCandidate,
            curSrc,
            curCan,
            candidateSrc,
            abortCurSrc;

        var imageData = img[pf.ns];
        var dpr = pf.DPR;

        curSrc = imageData.curSrc || img[curSrcProp];

        curCan =
            imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

        // if we have a current source, we might either become lazy or give this source some advantage
        if (curCan && curCan.set === candidates[0].set) {
            // if browser can abort image request and the image has a higher pixel density than needed
            // and this image isn't downloaded yet, we skip next part and try to save bandwidth
            abortCurSrc =
                supportAbort && !img.complete && curCan.res - 0.1 > dpr;

            if (!abortCurSrc) {
                curCan.cached = true;

                // if current candidate is "best", "better" or "okay",
                // set it to bestCandidate
                if (curCan.res >= dpr) {
                    bestCandidate = curCan;
                }
            }
        }

        if (!bestCandidate) {
            candidates.sort(ascendingSort);

            length = candidates.length;
            bestCandidate = candidates[length - 1];

            for (i = 0; i < length; i++) {
                candidate = candidates[i];
                if (candidate.res >= dpr) {
                    j = i - 1;

                    // we have found the perfect candidate,
                    // but let's improve this a little bit with some assumptions ;-)
                    if (
                        candidates[j] &&
                        (abortCurSrc || curSrc !== pf.makeUrl(candidate.url)) &&
                        chooseLowRes(
                            candidates[j].res,
                            candidate.res,
                            dpr,
                            candidates[j].cached
                        )
                    ) {
                        bestCandidate = candidates[j];
                    } else {
                        bestCandidate = candidate;
                    }
                    break;
                }
            }
        }

        if (bestCandidate) {
            candidateSrc = pf.makeUrl(bestCandidate.url);

            imageData.curSrc = candidateSrc;
            imageData.curCan = bestCandidate;

            if (candidateSrc !== curSrc) {
                pf.setSrc(img, bestCandidate);
            }
            pf.setSize(img);
        }
    };

    pf.setSrc = function (img, bestCandidate) {
        var origWidth;
        img.src = bestCandidate.url;

        // although this is a specific Safari issue, we don't want to take too much different code paths
        if (bestCandidate.set.type === "image/svg+xml") {
            origWidth = img.style.width;
            img.style.width = img.offsetWidth + 1 + "px";

            // next line only should trigger a repaint
            // if... is only done to trick dead code removal
            if (img.offsetWidth + 1) {
                img.style.width = origWidth;
            }
        }
    };

    pf.getSet = function (img) {
        var i, set, supportsType;
        var match = false;
        var sets = img[pf.ns].sets;

        for (i = 0; i < sets.length && !match; i++) {
            set = sets[i];

            if (
                !set.srcset ||
                !pf.matchesMedia(set.media) ||
                !(supportsType = pf.supportsType(set.type))
            ) {
                continue;
            }

            if (supportsType === "pending") {
                set = supportsType;
            }

            match = set;
            break;
        }

        return match;
    };

    pf.parseSets = function (element, parent, options) {
        var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

        var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
        var imageData = element[pf.ns];

        if (imageData.src === undefined || options.src) {
            imageData.src = getImgAttr.call(element, "src");
            if (imageData.src) {
                setImgAttr.call(element, srcAttr, imageData.src);
            } else {
                removeImgAttr.call(element, srcAttr);
            }
        }

        if (
            imageData.srcset === undefined ||
            options.srcset ||
            !pf.supSrcset ||
            element.srcset
        ) {
            srcsetAttribute = getImgAttr.call(element, "srcset");
            imageData.srcset = srcsetAttribute;
            srcsetParsed = true;
        }

        imageData.sets = [];

        if (hasPicture) {
            imageData.pic = true;
            getAllSourceElements(parent, imageData.sets);
        }

        if (imageData.srcset) {
            imageSet = {
                srcset: imageData.srcset,
                sizes: getImgAttr.call(element, "sizes"),
            };

            imageData.sets.push(imageSet);

            isWDescripor =
                (alwaysCheckWDescriptor || imageData.src) &&
                regWDesc.test(imageData.srcset || "");

            // add normal src as candidate, if source has no w descriptor
            if (
                !isWDescripor &&
                imageData.src &&
                !getCandidateForSrc(imageData.src, imageSet) &&
                !imageSet.has1x
            ) {
                imageSet.srcset += ", " + imageData.src;
                imageSet.cands.push({
                    url: imageData.src,
                    d: 1,
                    set: imageSet,
                });
            }
        } else if (imageData.src) {
            imageData.sets.push({
                srcset: imageData.src,
                sizes: null,
            });
        }

        imageData.curCan = null;
        imageData.curSrc = undefined;

        // if img has picture or the srcset was removed or has a srcset and does not support srcset at all
        // or has a w descriptor (and does not support sizes) set support to false to evaluate
        imageData.supported = !(
            hasPicture ||
            (imageSet && !pf.supSrcset) ||
            (isWDescripor && !pf.supSizes)
        );

        if (srcsetParsed && pf.supSrcset && !imageData.supported) {
            if (srcsetAttribute) {
                setImgAttr.call(element, srcsetAttr, srcsetAttribute);
                element.srcset = "";
            } else {
                removeImgAttr.call(element, srcsetAttr);
            }
        }

        if (
            imageData.supported &&
            !imageData.srcset &&
            ((!imageData.src && element.src) ||
                element.src !== pf.makeUrl(imageData.src))
        ) {
            if (imageData.src === null) {
                element.removeAttribute("src");
            } else {
                element.src = imageData.src;
            }
        }

        imageData.parsed = true;
    };

    pf.fillImg = function (element, options) {
        var imageData;
        var extreme = options.reselect || options.reevaluate;

        // expando for caching data on the img
        if (!element[pf.ns]) {
            element[pf.ns] = {};
        }

        imageData = element[pf.ns];

        // if the element has already been evaluated, skip it
        // unless `options.reevaluate` is set to true ( this, for example,
        // is set to true when running `picturefill` on `resize` ).
        if (!extreme && imageData.evaled === evalId) {
            return;
        }

        if (!imageData.parsed || options.reevaluate) {
            pf.parseSets(element, element.parentNode, options);
        }

        if (!imageData.supported) {
            applyBestCandidate(element);
        } else {
            imageData.evaled = evalId;
        }
    };

    pf.setupRun = function () {
        if (!alreadyRun || isVwDirty || DPR !== window.devicePixelRatio) {
            updateMetrics();
        }
    };

    // If picture is supported, well, that's awesome.
    if (pf.supPicture) {
        picturefill = noop;
        pf.fillImg = noop;
    } else {
        // Set up picture polyfill by polling the document
        (function () {
            var isDomReady;
            var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

            var run = function () {
                var readyState = document.readyState || "";

                timerId = setTimeout(run, readyState === "loading" ? 200 : 999);
                if (document.body) {
                    pf.fillImgs();
                    isDomReady = isDomReady || regReady.test(readyState);
                    if (isDomReady) {
                        clearTimeout(timerId);
                    }
                }
            };

            var timerId = setTimeout(run, document.body ? 9 : 99);

            // Also attach picturefill on resize and readystatechange
            // http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
            var debounce = function (func, wait) {
                var timeout, timestamp;
                var later = function () {
                    var last = new Date() - timestamp;

                    if (last < wait) {
                        timeout = setTimeout(later, wait - last);
                    } else {
                        timeout = null;
                        func();
                    }
                };

                return function () {
                    timestamp = new Date();

                    if (!timeout) {
                        timeout = setTimeout(later, wait);
                    }
                };
            };
            var lastClientWidth = docElem.clientHeight;
            var onResize = function () {
                isVwDirty =
                    Math.max(window.innerWidth || 0, docElem.clientWidth) !==
                        units.width || docElem.clientHeight !== lastClientWidth;
                lastClientWidth = docElem.clientHeight;
                if (isVwDirty) {
                    pf.fillImgs();
                }
            };

            on(window, "resize", debounce(onResize, 99));
            on(document, "readystatechange", run);
        })();
    }

    pf.picturefill = picturefill;
    //use this internally for easy monkey patching/performance testing
    pf.fillImgs = picturefill;
    pf.teardownRun = noop;

    /* expose methods for testing */
    picturefill._ = pf;

    window.picturefillCFG = {
        pf: pf,
        push: function (args) {
            var name = args.shift();
            if (typeof pf[name] === "function") {
                pf[name].apply(pf, args);
            } else {
                cfg[name] = args[0];
                if (alreadyRun) {
                    pf.fillImgs({ reselect: true });
                }
            }
        },
    };

    while (setOptions && setOptions.length) {
        window.picturefillCFG.push(setOptions.shift());
    }

    /* expose picturefill */
    window.picturefill = picturefill;

    /* expose picturefill */
    if (typeof module === "object" && typeof module.exports === "object") {
        // CommonJS, just export
        module.exports = picturefill;
    } else if (typeof define === "function" && define.amd) {
        // AMD support
        define("picturefill", function () {
            return picturefill;
        });
    }

    // IE8 evals this sync, so it must be the last thing we do
    if (!pf.supPicture) {
        types["image/webp"] = detectTypeSupport(
            "image/webp",
            "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="
        );
    }
})(window, document);

/*!
 * Bez @VERSION
 * http://github.com/rdallasgray/bez
 *
 * A plugin to convert CSS3 cubic-bezier co-ordinates to jQuery-compatible easing functions
 *
 * With thanks to Nikolay Nemshilov for clarification on the cubic-bezier maths
 * See http://st-on-it.blogspot.com/2011/05/calculating-cubic-bezier-function.html
 *
 * Copyright @YEAR Robert Dallas Gray. All rights reserved.
 * Provided under the FreeBSD license: https://github.com/rdallasgray/bez/blob/master/LICENSE.txt
 */
(function (factory) {
    if (typeof exports === "object") {
        factory(require("jquery"));
    } else if (typeof define === "function" && define.amd) {
        define(["jquery"], factory);
    } else {
        factory(jQuery);
    }
})(function ($) {
    $.extend({
        bez: function (encodedFuncName, coOrdArray) {
            if ($.isArray(encodedFuncName)) {
                coOrdArray = encodedFuncName;
                encodedFuncName =
                    "bez_" + coOrdArray.join("_").replace(/\./g, "p");
            }
            if (typeof $.easing[encodedFuncName] !== "function") {
                var polyBez = function (p1, p2) {
                    var A = [null, null],
                        B = [null, null],
                        C = [null, null],
                        bezCoOrd = function (t, ax) {
                            (C[ax] = 3 * p1[ax]),
                                (B[ax] = 3 * (p2[ax] - p1[ax]) - C[ax]),
                                (A[ax] = 1 - C[ax] - B[ax]);
                            return t * (C[ax] + t * (B[ax] + t * A[ax]));
                        },
                        xDeriv = function (t) {
                            return C[0] + t * (2 * B[0] + 3 * A[0] * t);
                        },
                        xForT = function (t) {
                            var x = t,
                                i = 0,
                                z;
                            while (++i < 14) {
                                z = bezCoOrd(x, 0) - t;
                                if (Math.abs(z) < 1e-3) break;
                                x -= z / xDeriv(x);
                            }
                            return x;
                        };
                    return function (t) {
                        return bezCoOrd(xForT(t), 1);
                    };
                };
                $.easing[encodedFuncName] = function (x, t, b, c, d) {
                    return (
                        c *
                            polyBez(
                                [coOrdArray[0], coOrdArray[1]],
                                [coOrdArray[2], coOrdArray[3]]
                            )(t / d) +
                        b
                    );
                };
            }
            return encodedFuncName;
        },
    });
});

/* jQuery tubular plugin
|* by Sean McCambridge
|* http://www.seanmccambridge.com/tubular
|* version: 1.0
|* updated: October 1, 2012
|* since 2010
|* licensed under the MIT License
|* Enjoy.
|*
|* Thanks,
|* Sean */

(function ($, window) {
    // test for feature support and return if failure

    // defaults
    var defaults = {
        ratio: 16 / 9, // usually either 4/3 or 16/9 -- tweak as needed
        videoId: "ZCAnLxRvNNc", // toy robot in space is a good default, no?
        mute: true,
        repeat: true,
        width: $(window).width(),
        wrapperZIndex: 99,
        playButtonClass: "tubular-play",
        pauseButtonClass: "tubular-pause",
        muteButtonClass: "tubular-mute",
        volumeUpClass: "tubular-volume-up",
        volumeDownClass: "tubular-volume-down",
        increaseVolumeBy: 10,
        start: 0,
    };

    // methods

    var tubular = function (node, options) {
        // should be called on the wrapper div
        var options = $.extend({}, defaults, options),
            $body = $("#top"); // cache body node
        $node = $(node); // cache wrapper node

        // build container
        var tubularContainer =
            '<div id="tubular-container" style="overflow: hidden; position: absolute; z-index: 1; width: 100%; height: 100%"><div id="tubular-player" style="position: absolute"></div></div><div id="tubular-shield" style="width: 100%; height: 100%; z-index: 2; position: absolute; left: 0; top: 0;"></div>';

        // set up css prereq's, inject tubular container and set up wrapper defaults
        $("#top").css({ width: "100%", height: "100%" });
        $body.prepend(tubularContainer);
        $node.css({ position: "relative", "z-index": options.wrapperZIndex });

        // set up iframe player, use global scope so YT api can talk
        window.player;
        window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player("tubular-player", {
                width: options.width,
                height: Math.ceil(options.width / options.ratio),
                videoId: options.videoId,
                playerVars: {
                    controls: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    wmode: "transparent",
                },
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange,
                },
            });
        };

        window.onPlayerReady = function (e) {
            resize();
            if (options.mute) e.target.mute();
            e.target.seekTo(options.start);
            e.target.playVideo();
        };

        window.onPlayerStateChange = function (state) {
            if (state.data === 0 && options.repeat) {
                // video ended and repeat option is set true
                player.seekTo(options.start); // restart
            }
        };

        // resize handler updates width, height and offset of player after resize/init
        var resize = function () {
            var width = $(window).width(),
                pWidth, // player width, to be defined
                height = $(window).height(),
                pHeight, // player height, tbd
                $tubularPlayer = $("#tubular-player");

            // when screen aspect ratio differs from video, video must center and underlay one dimension

            if (width / options.ratio < height) {
                // if new video height < window height (gap underneath)
                pWidth = Math.ceil(height * options.ratio); // get new player width
                $tubularPlayer
                    .width(pWidth)
                    .height(height)
                    .css({ left: (width - pWidth) / 2, top: 0 }); // player width is greater, offset left; reset top
            } else {
                // new video width < window width (gap to right)
                pHeight = Math.ceil(width / options.ratio); // get new player height
                $tubularPlayer
                    .width(width)
                    .height(pHeight)
                    .css({ left: 0, top: (height - pHeight) / 2 }); // player height is greater, offset top; reset left
            }
        };

        // events
        $(window).on("resize.tubular", function () {
            resize();
        });

        $("#top")
            .on("click", "." + options.playButtonClass, function (e) {
                // play button
                e.preventDefault();
                player.playVideo();
            })
            .on("click", "." + options.pauseButtonClass, function (e) {
                // pause button
                e.preventDefault();
                player.pauseVideo();
            })
            .on("click", "." + options.muteButtonClass, function (e) {
                // mute button
                e.preventDefault();
                player.isMuted() ? player.unMute() : player.mute();
            })
            .on("click", "." + options.volumeDownClass, function (e) {
                // volume down button
                e.preventDefault();
                var currentVolume = player.getVolume();
                if (currentVolume < options.increaseVolumeBy)
                    currentVolume = options.increaseVolumeBy;
                player.setVolume(currentVolume - options.increaseVolumeBy);
            })
            .on("click", "." + options.volumeUpClass, function (e) {
                // volume up button
                e.preventDefault();
                if (player.isMuted()) player.unMute(); // if mute is on, unmute
                var currentVolume = player.getVolume();
                if (currentVolume > 100 - options.increaseVolumeBy)
                    currentVolume = 100 - options.increaseVolumeBy;
                player.setVolume(currentVolume + options.increaseVolumeBy);
            });
    };

    // load yt iframe js api

    var tag = document.createElement("script");
    tag.src = "//www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // create plugin

    $.fn.tubular = function (options) {
        return this.each(function () {
            if (!$.data(this, "tubular_instantiated")) {
                // let's only run one
                $.data(this, "tubular_instantiated", tubular(this, options));
            }
        });
    };
})(jQuery, window);

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function ($element) {
        var focusClass = "js-focus-hidden";

        $element
            .first()
            .attr("tabIndex", "-1")
            .focus()
            .addClass(focusClass)
            .one("blur", callback);

        function callback() {
            $element.first().removeClass(focusClass).removeAttr("tabindex");
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function () {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function () {
        $("a[href*=#]").on(
            "click",
            function (evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function (options) {
        var eventName = options.namespace
            ? "focusin." + options.namespace
            : "focusin";

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr("tabindex", "-1");
        options.$elementToFocus.focus();

        $(document).on(eventName, function (evt) {
            if (
                options.$container[0] !== evt.target &&
                !options.$container.has(evt.target).length
            ) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function (options) {
        var eventName = options.namespace
            ? "focusin." + options.namespace
            : "focusin";

        if (options.$container && options.$container.length) {
            options.$container.removeAttr("tabindex");
        }

        $(document).off(eventName);
    },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
        }
        return cookieEnabled;
    },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
    },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function (options) {
        var tableWrapperClass =
            typeof options.tableWrapperClass === "undefined"
                ? ""
                : options.tableWrapperClass;

        options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function (options) {
        var iframeWrapperClass =
            typeof options.iframeWrapperClass === "undefined"
                ? ""
                : options.iframeWrapperClass;

        options.$iframes.each(function () {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    },
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:section:reorder", this._onReorder.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr("data-section-id");
        var type = $container.attr("data-section-type");

        constructor = constructor || this.constructors[type];

        if (typeof constructor === "undefined") {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container,
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );
    },

    _onSelect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onSelect === "function") {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onDeselect === "function") {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onReorder === "function") {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = slate.utils.findInstance(
            this.instances,
            "id",
            evt.detail.sectionId
        );

        if (instance && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        $("[data-section-type=" + type + "]").each(
            function (index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
    var moneyFormat = "${{amount}}";

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ",");
            decimal = slate.utils.defaultTo(decimal, ".");

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : "";

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_space_separator":
                value = formatWithDelimiters(cents, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ",", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney,
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === "string") {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === "master") {
            return this.removeProtocol(src);
        }

        var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol,
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on(
            "change",
            this._onSelectChange.bind(this)
        );
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var currentOptions = $.map(
                $(this.singleOptionSelector, this.$container),
                function (element) {
                    var $element = $(element);
                    var type = $element.attr("type");
                    var currentOption = {};

                    if (type === "radio" || type === "checkbox") {
                        if ($element[0].checked) {
                            currentOption.value = $element.val();
                            currentOption.index = $element.data("index");

                            return currentOption;
                        } else {
                            return false;
                        }
                    } else {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data("index");

                        return currentOption;
                    }
                }
            );

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function (variant) {
                var satisfied = true;

                selectedValues.forEach(function (option) {
                    if (satisfied) {
                        satisfied = option.value === variant[option.index];
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: "variantChange",
                variant: variant,
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (
                !variant.featured_image ||
                variantImage.src === currentVariantImage.src
            ) {
                return;
            }

            this.$container.trigger({
                type: "variantImageChange",
                variant: variant,
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {
            if (
                variant.price === this.currentVariant.price &&
                variant.compare_at_price ===
                    this.currentVariant.compare_at_price
            ) {
                return;
            }

            this.$container.trigger({
                type: "variantPriceChange",
                variant: variant,
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?variant=" +
                variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        },
    });

    return Variants;
})();
(function () {
    // for aladdin.popin.cc
    var $window = $(window);
    var $body = $("body");
    var $main = $("main");
    var $section = $("section");
    var $header = $("#header");
    var $productNavigationBack = $("#product-navigation-back");
    var $keyv = $(".keyv");
    var $topIndicator = $("#top #indicator p");
    var $faq = $(".faq");
    var $menuOverlay = $("#menu-overlay");
    var $menuOverlayInner = $("#menu-overlay-inner");
    var $menuTrigger = $(".menu-trigger");
    var $menuLi = $menuOverlayInner.find("li");
    var $scrollTrigger = $(".scroll-trigger");
    var $buyNow = $(".buy-now");
    var $animBox = $(".anim-box");
    var $life = $("#life");
    var $lifeBox = $(".life-box");
    var $lifeCycle = $(".life-cycle");
    var $lifeImage = $(".life-image");
    var $lifeText = $(".life-text");
    var $lifeArrow = $(".life-arrow");
    var $goToTop = $("#go-to-top");
    var $tabWrapper = $("#tab-wrapper");
    var $kakakuIcon = $("#kakaku-icon");
    var $kakakuClose = $("#kakaku-close");
    var $cartOverlay = $("#shopify-section-cart-overlay");
    var $cartOverlayClose = $(".cart-overlay-close");
    var $productPage = $("#product-page");
    var $cartPage = $("#cart-page");
    var $lp201811011_1 = $("#lp20181101-1-new");
    var $lp201811011_2 = $("#lp20181101-2-new");
    var $lp201811011_3 = $("#lp20181101-3-new");
    var $product_family = $("#product-family");
    var $beloved = $("#belovedMainContent");
    var $product_entertainment = $("#product-entertainment");
    var $popin_aladdin_for_rent = $("#popin-aladdin");
    var $popin_aladdin_for_rent_sale = $("#popin-aladdin");
    var $product_family2 = $(
        "#家族みんなで楽しめるプロジェクター付きシーリングライト"
    );
    var $product_entertainment2 = $(
        "#一人でもカップルでも楽しめる-プロジェクター付きシーリングライト"
    );
    var $uaCart = $(".ua-cart");
    var $originalSlide = $(".original-contents-slide");
    var $nav = $(".nav");
    var windowW = window.innerWidth;
    var windowH = window.innerHeight;
    var _lifeIndex = 0;
    var _originalIndex = 0;
    var _zIndex = 1;
    var _index = 0;
    var _startPos = 0;
    var _animate = true;
    var _initial = true;
    var _lifeTimer, _topSlider, _originalSlider, _lastY;
    var parallax = document.getElementsByClassName("parallax");
    var parallaxArray = [];

    class Parallax {
        constructor(elm, easing, offsetY = 0, offsetX = 0) {
            this.elm = elm;
            this.nextY = 0;
            this.nextX = 0;
            this.curY = 0;
            this.curX = 0;
            this.offsetY = elm.offsetTop + offsetY;
            this.offsetX = elm.offsetLeft + offsetX;
            this.easing = easing;
            this.height = 0;
        }
        setValue(nextY = 0, nextX = 0) {
            this.nextX = nextX;
            this.nextY = nextY;
        }

        move() {
            this.curY += (this.nextY - this.curY) * this.easing;
            this.curX += (this.nextX - this.curX) * this.easing;
            this.elm.setAttribute(
                "style",
                "transform: translate3d(0," + parseFloat(this.curY) + "px, 0);"
            );
        }

        map(value, start1, end1, start2, end2) {
            return (
                start2 + (end2 - start2) * ((value - start1) / (end1 - start1))
            );
        }
    }

    function parallaxFunc() {
        for (var i = 0; i < parallaxArray.length; i++) {
            var parallax = parallaxArray[i];
            var nextValueY =
                (parallax.elm.parentNode.offsetTop - _startPos) * 0.4;
            // var nextValueY = ( (parallax.elm.offsetTop - _startPos) * 1.2 );

            parallax.setValue(nextValueY);
            parallax.move();
        }
        // requestAnimationFrame(parallaxFunc());
    }

    if ($nav.length != 0) {
        $nav.on("click", function () {
            var height;
            if ($nav.hasClass("active")) {
                if (window.innerWidth < 768) {
                    height = $nav.height() - $nav.find("ul").height() + "px";
                } else {
                    height = "auto";
                }
                $nav.removeClass("active");
                $nav.css("height", height);
            } else {
                if (window.innerWidth < 768) {
                    height = $nav.height() + $nav.find("ul").height() + "px";
                } else {
                    height = "auto";
                }
                $nav.addClass("active");
                $nav.css("height", height);
            }
        });
    }

    if (parallax.length != 0) {
        for (var i = 0; i < parallax.length; i++) {
            var elm = parallax[i];
            var easing = parseFloat(elm.getAttribute("data-easing"));
            var offsetH = parseFloat(elm.getAttribute("data-offseth"));
            var thisParallax = new Parallax(elm, easing, offsetH);

            parallaxArray.push(thisParallax);
        }
        parallaxFunc();
    }

    function changeOriginal() {
        var $activeOriginal = $originalSlide.filter(".active");

        $originalSlide.removeClass("active");
        $originalSlide.eq(_originalIndex).addClass("active");
        setTimeout(function () {
            _animate = true;
        }, 4000);
    }

    function changeKeyv() {
        var $activeKeyv = $keyv.filter(".active");

        $topIndicator.removeClass("active");
        $keyv.eq(_index).css("zIndex", _zIndex);
        $keyv.eq(_index).addClass("active");
        $topIndicator.eq(_index).addClass("active");
        setTimeout(function () {
            $activeKeyv.addClass("reset").removeClass("active");
            _animate = true;
            _zIndex++;
            setTimeout(function () {
                $activeKeyv.removeClass("reset");
            }, 10);
        }, 2500);
    }

    function slide() {
        if (_index < $keyv.length - 1) {
            _index++;
        } else {
            _index = 0;
        }
        changeKeyv();
    }

    function originalSlide() {
        if (!_animate) {
            return;
        } else {
            _animate = false;
            if (_originalIndex < $originalSlide.length - 1) {
                _originalIndex++;
            } else {
                _originalIndex = 0;
            }
            changeOriginal();
        }
    }

    function initialAnimation() {
        $animBox.each(function () {
            var $self = $(this);
            var elemPos = $self.offset().top;
            var scrollPos = $window.scrollTop();

            if (
                scrollPos > (elemPos - windowH) * 1.05 &&
                !$self.hasClass("active")
            ) {
                $self.removeClass("reset").addClass("active");
            }
            if (
                scrollPos < (elemPos - windowH) * 1.05 &&
                $self.hasClass("active")
            ) {
                // $self.removeClass('active').addClass('reset');
            }
        });
    }

    function lifeAnimation() {
        $lifeCycle.removeClass("active");
        $lifeCycle.eq(_lifeIndex).addClass("active");
        $lifeImage.removeClass("active");
        $lifeText.removeClass("active");
        $lifeImage.eq(_lifeIndex).addClass("active");
        $lifeText.eq(_lifeIndex).addClass("active");
        if (_lifeIndex < 5 && $life.hasClass("night")) {
            $life.removeClass("night");
            $life.addClass("morning");
        } else if (_lifeIndex > 4 && $life.hasClass("morning")) {
            $life.addClass("night");
            $life.removeClass("morning");
        }
    }

    function lifeSlide() {
        _lifeTimer = setInterval(function () {
            lifeAnimation();
            if (_lifeIndex < $lifeImage.length - 1) {
                _lifeIndex++;
            } else {
                _lifeIndex = 0;
            }
        }, 5000);
    }

    function clearLife() {
        clearInterval(_lifeTimer);
    }

    function checkLoad() {
        $body.addClass("loaded");
    }

    if (
        !window.location.href.match(/pages/) &&
        !window.location.href.match(/blogs/)
    ) {
        checkLoad();
    }

    var addSliderFunc = function () {
        var $slideWrapperInner = $(".slide-wrapper-inner");
        var timeout = function ($thisWrapper, time) {
            setTimeout(function () {
                var $clone, $removeElm;
                var move =
                    $(".insta").width() +
                    parseFloat($(".insta").css("marginRight")) * 2;

                if ($thisWrapper.parent().hasClass("right")) {
                    $removeElm = $thisWrapper
                        .find(".insta")
                        .eq($thisWrapper.find(".insta").length - 1);
                    $clone = $removeElm.clone();
                    $thisWrapper.prepend($clone);
                } else {
                    $removeElm = $thisWrapper.find(".insta").eq(0);
                    $clone = $removeElm.clone();
                    $thisWrapper.append($clone);
                    move = -1 * move;
                }

                $removeElm.remove();
                $thisWrapper
                    .addClass("reset")
                    .css("transform", "translate3d(0, 0, 0)");

                setTimeout(function () {
                    $thisWrapper.removeClass("reset").css({
                        transform: "translate3d(" + move + "px, 0, 0)",
                    });
                    timeout($thisWrapper, 6000);
                }, 100);
            }, time);
        };
        function sliderInit() {
            var move =
                $(".insta").width() +
                parseFloat($(".insta").css("marginRight")) * 2;
            for (var i = 0; i < $slideWrapperInner.length; i++) {
                var swi = $slideWrapperInner.eq(i);
                swi.css({
                    transform:
                        "translate3d(" +
                        (i === 0 ? -1 * move : move) +
                        "px, 0, 0)",
                    width: move * swi.find(".insta").length + "px",
                });
                timeout($slideWrapperInner.eq(i), 6000);
            }
        }
        sliderInit();

        // disable logo click
        var $logoA = $("#logo a");
        $logoA.css("cursor", "default");
        $logoA.on("click", function (e) {
            e.preventDefault();
        });
    };

    // for slider
    $lp201811011_1.each(addSliderFunc);
    $lp201811011_2.each(addSliderFunc);
    $lp201811011_3.each(addSliderFunc);
    $product_family.each(addSliderFunc);
    $product_family2.each(addSliderFunc);
    $product_entertainment2.each(addSliderFunc);
    $product_entertainment.each(addSliderFunc);
    $beloved.each(addSliderFunc);

    // for locksmith
    var locksmith_counter = 0;
    var locksmith = function () {
        locksmith_counter++;
        if (locksmith_counter < 10) {
            var locksmith_passcode = $("#locksmith_passcode");
            if (locksmith_passcode.length > 0) {
                locksmith_passcode.attr(
                    "placeholder",
                    "パスコードを入力してください"
                );
            } else {
                setTimeout(locksmith, 500);
            }
        }
    };
    locksmith();

    $cartPage.each(function () {
        var $spinner = $(".spinner");

        $spinner.on("click", function () {
            if ($(this).hasClass("spinner_up")) {
                spinner("up", this);
                console.log("up");
            } else {
                spinner("down", this);
                console.log("down");
            }
        });

        function spinner(dir, self) {
            var $input = $(self).parent().parent().find(".cart-input");
            var curVal = parseInt($input.val());
            if (curVal === 0) {
                console.log("SOLD OUT");
                return;
            } else {
                if (dir === "up") {
                    if (curVal < parseInt($input[0].getAttribute("max"))) {
                        curVal++;
                        $input.val(curVal);
                    }
                } else {
                    if (curVal > 0) {
                        curVal--;
                        $input.val(curVal);
                    }
                }
                changeTotal(self);
            }
        }

        function changeTotal(self) {
            var $total = $(self)
                .parent()
                .parent()
                .parent()
                .parent()
                .find(".total .t");
            var $input = $(self).parent().parent().find(".cart-input");
            var quantity = parseInt($input.val(), 10);
            var total =
                quantity *
                $input
                    .parent()
                    .parent()
                    .parent()
                    .find(".price .p")
                    .html()
                    .replace(/[^0-9^\.]/g, "");
            console.log($total);
            total = parseInt(total, 10);
            $total.text("¥" + total.toLocaleString());
        }
    });

    $productPage.each(function () {
        var $input = $("#Quantity");
        var $total = $(".cart-total");
        var $spinner = $(".spinner");
        var curVal = parseInt($input.val());

        var price = $("#popin-price")
            .html()
            .replace(/[^0-9^\.]/g, "");
        price = parseInt(price, 10);

        $productPage.delegate("input[type='radio']", "click", function () {
            // オプション価格取得
            var index = $productPage.find("input[type='radio']").index(this);
            var variantPrice = window.variants.product.variants[index].price
                .toString()
                .slice(0, -2);
            var variantId = window.variants.product.variants[index].id;
            var variantInventory = $input.attr("max" + variantId);

            if (curVal > variantInventory) {
                curVal = parseInt(variantInventory);
                $input.val(curVal);
            }

            variantPrice = parseInt(variantPrice);
            price = curVal * variantPrice;

            $total.text("¥" + price.toLocaleString());
            $productPage.find(".option-label").removeClass("selected");
            if (!$(this).next().hasClass("selected")) {
                $(this).next().addClass("selected");
            } else {
                $(this).next().removeClass("selected");
            }
        });

        $spinner.on("click", function () {
            if ($(this).hasClass("spinner_up")) {
                spinner("up");
            } else {
                spinner("down");
            }
        });

        function spinner(dir) {
            if (curVal === 0) {
                console.log("SOLD OUT");
                return;
            } else {
                if (dir === "up") {
                    if (curVal < parseInt($input[0].getAttribute("max"))) {
                        curVal++;
                        $input.val(curVal);
                    }
                } else {
                    if (curVal > 1) {
                        curVal--;
                        $input.val(curVal);
                    }
                }
                changeTotal();
            }
        }

        function changeTotal() {
            var quantity = parseInt($input.val(), 10);
            var total = quantity * price;
            $total.text("¥" + total.toLocaleString());
        }
    });

    if (
        location.href.indexOf(
            "https://aladdin.popin.cc/products/popin-aladdin-rent"
        ) > -1
    ) {
        // for rent
        $popin_aladdin_for_rent.each(function () {
            var html =
                "\
<div style='margin-bottom:45px;'>\
<p><span style='font-size:28px;line-height:2;'>＼先着100名様限定！／<br>\
世界初の3 in1スマートライト「popIn Aladdin」お試しキャンペーン</p></br>\
<p style='line-height:2;'>\
<span style='color:red;'>予想を遥かに超えるスピードでのご応募を頂き約5時間で終了となりました。<br>沢山のご応募有難うございました。</span><br><br>\
「popIn Aladdin」に興味を持っていただいている皆さまへ<br><br>\
「我が家でも簡単に設置できるのか確認したい」「まずは実際に寝室で試してみたい」という皆さまの声にお応えして、本製品をご自宅で体験いただける機会を用意いたしました。今回は3,000円（税・送料込）で1週間（7泊8日）ご利用いただけます。先着100名様限定となります。<br><br>\
人気の動画サービスやテレビ、スマートフォンを大画面で楽しめて、あなたの寝室をオシャレで豊かな空間に変える「popIn Aladdin」を、この機会にぜひお試しください。詳細は下記からご確認いただけます。<br>\
</p>\
<p style='line-height:2;'>\
<br>\
<b>■ キャンペーン概要</b><br>\
「popIn Aladdin」お試しキャンペーン<br>\
期間：2018年11月15日(木)～11月18日(日) 100名様到達次第終了<br>\
対象者：貸出条件と<a href='https://cdn.shopify.com/s/files/1/2791/5352/files/popIn_Aladdin_for_rent.pdf?1298022629963410716' target='_blank'>利用規約</a>に同意いただける方<br>\
お試しキャンペーンの条件：<br>\
・お一人様1商品、1回限りとなります。<br>\
・お試し期間は1週間（7泊8日）となります。<br>\
・お試しいただけるご本人様のお申し込みにてお願いいたします。<br><br>\
＜注意事項：必ずお読みください＞<br>\
・商品は1〜2営業日以内に発送します。発送日のご指定は受け付けておりません。<br>\
・お試し期間は、商品の到着日より起算いたします。<br>\
・商品到着後8日目までにご返却ください。<br>\
・お試し期間の延長は不可となります。<br>\
</p></div>";

            var scene =
                "\
<div id='key' style='margin:20px;'>\
  <a href='https://aladdin.popin.cc/pages/home-theater' target='_blank'><img style='width:300px;margin:5px 0px;' src='//cdn.shopify.com/s/files/1/2791/5352/files/logo_general.jpeg?5734559746390885248' width='600/'>  </a>\
  <a href='https://aladdin.popin.cc/pages/product-family' target='_blank'><img style='width:300px;margin:5px 0px;' src='//cdn.shopify.com/s/files/1/2791/5352/files/special.002.jpeg?5734559746390885248' width='600/'></a>\
  <a href='https://aladdin.popin.cc/pages/product-entertainment' target='_blank'><img style='width:300px;margin:5px 0px;' src='//cdn.shopify.com/s/files/1/2791/5352/files/special.003.jpeg?5734559746390885248' width='600/'></a>\
</div>\
";

            $(html).insertBefore("#cart-wrapper");
            $(scene).insertAfter("#cart-wrapper");

            $("#product-desc").remove();

            $("#Quantity").attr("readonly", true);
        });
    }

    if (
        location.href.indexOf(
            "https://aladdin.popin.cc/products/popin-aladdin-trial"
        ) > -1
    ) {
        // for rent
        $popin_aladdin_for_rent.each(function () {
            var html = "";
            var scene = "";

            $(html).insertBefore("#cart-wrapper");
            $(scene).insertAfter("#cart-wrapper");

            $("#product-desc").remove();

            $("#Quantity").attr("readonly", true);
        });
    }

    if (
        location.href.indexOf(
            "https://aladdin.popin.cc/products/popin-aladdin-for-hills"
        ) > -1
    ) {
        // for rent
        $popin_aladdin_for_rent.each(function () {
            var html = "";
            var scene = "";

            $(html).insertBefore("#cart-wrapper");
            $(scene).insertAfter("#cart-wrapper");

            $("#product-desc").remove();

            $("#Quantity").attr("readonly", true);
        });
    }

    if (
        location.href.indexOf(
            "https://aladdin.popin.cc/products/popin-aladdin-for-rent-sale"
        ) > -1
    ) {
        // for rent
        $popin_aladdin_for_rent.each(function () {
            var html =
                "\
<div style='margin-bottom:45px;'>\
<p><span style='font-size:28px;line-height:2;'>＼購入前お試しキャンペーン対象様限定／<br>\
<p style='line-height:2;'>\
この度は「100名様限定！popIn Aladdin購入前お試しキャンペーン」にご応募いただき誠に有難うございました。\
また、popIn Aladdinにご興味をお持ちいただき、重ねて御礼申し上げます。\
<br><br>\
</p>\
<p style='line-height:2;'>\
<b>【年内最大の割引価格】</b><br>\
12月7日(金)から12月16日(日)までに、このページからご購入いただける場合に限り、64,830円（税込）でpopIn Aladdin1台をご購入頂けます。<br><br>\
今回お送りしておりますpopIn Aladdinは通常販売の新品ですので、ご購入の際はそのままご返却なしにご利用いただけます。以下のキャンペーン特設サイトから是非お試し期間中にご購入ください。\
</p></div>";

            $(html).insertBefore("#cart-wrapper");
            $("#product-desc").remove();
            $("#Quantity").attr("readonly", true);
            $("#cart-wrapper").css("margin-bottom", "40px");
        });
    }

    if (
        location.href.indexOf("https://aladdin.popin.cc/pages/orico_form/") > -1
    ) {
        var orico_form = jQuery("#orico_form");
        orico_form.on("submit", function (eve) {
            var isChecked = jQuery("#orico_checkbox").is(":checked");
            if (!isChecked) {
                eve.preventDefault();
                window.alert(
                    "プライバシーポリシー・個人情報についてをご確認ください"
                );
                return false;
            }
            var data = {
                name: {
                    label: "お名前",
                    name: "H_NAME",
                },
                addressno: {
                    label: "郵便番号",
                    name: "H_YUBIN",
                },
                address1: {
                    label: "お届け先住所",
                    name: "H_ADDR1",
                },
                address2: {
                    label: "お届け先住所",
                    name: "H_ADDR2",
                },
                tel: {
                    label: "電話番号",
                    name: "H_TELNO",
                },
            };

            for (var key in data) {
                var one = data[key];
                var val = $("input:text[name='" + one.name + "']").val();
                if (val === "") {
                    window.alert(one.label + "を入力してください");
                    $("input:text[name='" + one.name + "']").addClass("error");
                    return false;
                } else {
                    $("input:text[name='" + one.name + "']").removeClass(
                        "error"
                    );
                }
            }
        });

        var inputs = jQuery("#orico_form input[type=text]");
        inputs.on("keydown", function () {
            $(this).removeClass("error");
        });
    }

    // get url param
    function getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // for ambassador
    if (location.href.indexOf("ambassador") > -1) {
        var couponcode = getParam("couponcode");
        if (couponcode) {
            $("#coupon-url").attr(
                "href",
                "https://aladdin.popin.cc/discount/" +
                    couponcode +
                    "?redirect=%2Fproducts%2Fpopin-aladdin&coupon=true"
            );
        }
    }

    if (
        location.href.indexOf(
            "https://aladdin.popin.cc/products/popin-aladdin"
        ) > -1
    ) {
        var coupon = getParam("coupon");
        if (coupon === "true") {
            var html =
                '<div id="product-desc">販売価格は、税込、送料込です。<br><br>「カートへ追加」ボタンを押して、お客様情報の入力ページまで進むと、10,000円の割引クーポンが自動的に適用されます。<br>*このページ上の価格は、割引クーポンが適用されていません。</div>';

            $(html).insertAfter("#product-logo");
        }
    }

    // for media slide
    if (document.querySelector(".voice-list") !== null) {
        (function () {
            var slidePos = 0;

            var showSlide = function (eve) {
                var num = $(this).attr("number");
                slidePos = +num;
                voiceListSlide();
            };
            var $voiceList = jQuery(".voice-list");
            var $voiceWrapper = $voiceList.find(".voice-wrapper");
            var $dotsWrapper = jQuery(".dots-wrapper");
            var itemCount = $voiceWrapper.length;
            for (var i = 0, iz = itemCount; i < iz; i++) {
                var dotsSpan = document.createElement("span");
                dotsSpan.classList.add("dot");
                dotsSpan.setAttribute("number", i);
                $dotsWrapper.append(dotsSpan);
            }

            var $dots = jQuery(".dots-wrapper .dot");
            $dots.on("click", showSlide);

            var slideWidth = $voiceList.width();

            // update voicelist css
            var voiceListSlide = function () {
                $dots.each(function () {
                    $(this).removeClass("active");
                });
                $dots.eq(slidePos).addClass("active");
                var moveSlide = -slidePos * slideWidth;
                $voiceList.css(
                    "transform",
                    "translate3d(" + moveSlide + "px, 0, 0)"
                );
            };

            function voiceListNext() {
                slidePos += 1;
                if (slidePos === itemCount) {
                    slidePos = 0;
                }
                voiceListSlide();
            }
            var voiceSlideTimer = setInterval(function () {
                voiceListNext();
            }, 5000);
            voiceListSlide();
        })();
    }

    $topIndicator.on("click", function (e) {
        if (!_animate && windowW > 640) {
            return;
        } else {
            _animate = false;
            var $self = $(e.currentTarget);
            _index = $topIndicator.index($self);

            clearInterval(_topSlider);
            changeKeyv();

            _topSlider = null;
            setTimeout(function () {
                _animate = true;
                if (_topSlider === null) {
                    _topSlider = setInterval(slide, 11000);
                }
            }, 5000);
        }
    });

    $buyNow.on("click", function (e) {
        if ($(".product-section").length != 0) {
            window.location.href = "#shopify-section-featured-product-single";
        } else {
            window.location.href = "/#shopify-section-featured-product-single";
        }
    });

    $cartOverlay.find("main").on("click", function (e) {
        e.stopPropagation();
    });

    $cartOverlay.on("click", function () {
        if (!_animate) {
            return;
        } else {
            _animate = false;
            $cartOverlay.addClass("disactive");
            $cartOverlay
                .find("main")
                .one("transitionend webkitTransitionend", function (e) {
                    $cartOverlay.removeClass("active disactive");
                    _animate = true;
                });
        }
    });

    // for scroll cart-index
    if (location.pathname === "/") {
        var moveCartIndex = function () {
            if (location.hash === "#cart-index") {
                setTimeout(function () {
                    var pos = $("#cart-index").offset();
                    $("html,body").animate(
                        { scrollTop: pos.top },
                        1250,
                        $.bez([0.735, 0.005, 0.285, 1.0])
                    );
                }, 500);
            }
        };
        $(window).on("hashchange", moveCartIndex);
        $(document).ready(moveCartIndex);
        $(document).on("load", moveCartIndex);
    }

    $cartOverlayClose.on("click", function () {
        if (!_animate) {
            return;
        } else {
            _animate = false;
            $cartOverlay.addClass("disactive");
            $cartOverlay
                .find("main")
                .one("transitionend webkitTransitionend", function (e) {
                    $cartOverlay.removeClass("active disactive");
                    _animate = true;
                });
        }
    });

    $kakakuClose.on("click", function () {
        $kakakuIcon.addClass("out");
        $kakakuIcon.one("transitionend webkitTransitionend", function (e) {
            $kakakuIcon.remove();
        });
    });

    $lifeArrow.on("click", function (e) {
        if (!_animate) {
            return;
        } else {
            clearLife();
            var $self = $(e.currentTarget);

            if ($self.attr("id") === "life-arrow-left") {
                if (_lifeIndex !== 0) {
                    _lifeIndex--;
                } else {
                    _lifeIndex = $lifeImage.length - 1;
                }
            } else {
                if (_lifeIndex !== $lifeImage.length - 1) {
                    _lifeIndex++;
                } else {
                    _lifeIndex = 0;
                }
            }

            lifeAnimation();
            lifeSlide();
        }
    });

    $lifeBox.on("click", function (e) {
        if (!_animate) {
            return;
        } else {
            clearLife();
            var $self = $(e.currentTarget);

            if ($self.attr("id") === "life-left") {
                if (_lifeIndex !== 0) {
                    _lifeIndex--;
                } else {
                    _lifeIndex = $lifeImage.length - 1;
                }
            } else {
                if (_lifeIndex !== $lifeImage.length - 1) {
                    _lifeIndex++;
                } else {
                    _lifeIndex = 0;
                }
            }

            lifeAnimation();
            lifeSlide();
        }
    });

    $goToTop.on("click", function (e) {
        if (!_animate) {
            return;
        } else {
            _animate = false;
            $goToTop.removeClass("active");
            $("html,body").animate(
                { scrollTop: 0 },
                1250,
                $.bez([0.735, 0.005, 0.285, 1.0])
            );
            setTimeout(function () {
                _animate = true;
            }, 1250);
        }
    });

    $scrollTrigger.on("click", function (e) {
        $self = $(e.currentTarget);
        $target = $("#" + $self.data("target"));
        $scrollTrigger.removeClass("active");
        $self.addClass("active");
        $menuOverlay.css("height", 0);
        $menuTrigger.removeClass("active");

        if ($self.data("target") !== "undefined") {
            var top =
                $target[0].getBoundingClientRect().top + window.pageYOffset;
            if ($self.hasClass("spec-use-trigger")) {
                if (windowW < 640) {
                    top =
                        top -
                        window.innerWidth * 0.2691875 -
                        window.innerWidth * 0.10666666666666667;
                } else {
                    top = top - 102 - 100;
                }
            } else {
                setTimeout(function () {
                    window.location.hash = "#" + $self.data("target");
                }, 1250);
            }
            $("html, body").animate(
                { scrollTop: top },
                1250,
                $.bez([0.735, 0.005, 0.285, 1.0])
            );
        }

        // if ((window.location.href.match(/pages/) || window.location.href.match(/blogs/) || window.location.href.match(/cart/)) && $self.data('target') !== 'undefined') {
        //     window.location.href = '/' + '#' + $self.data('target');
        // } else {
        //     $('html, body').animate({scrollTop: $target.offset().top}, 1250, $.bez([0.735, 0.005, 0.285, 1.000]));
        //     setTimeout(function() {
        //         location.hash = '#' + $self.data('target');
        //     }, 1250);
        // }
    });

    var _mt_animate = true;
    $menuTrigger.on("click", function (e) {
        if (!_mt_animate) {
            return;
        } else {
            _mt_animate = false;
            var $self = $(e.currentTarget);

            $window.resize();

            if ($self.hasClass("active")) {
                $menuLi.removeClass("reset");
                $self.removeClass("active");
                $menuOverlay.removeClass("active");
                $menuOverlay.css({
                    height: 0,
                });
                setTimeout(function () {
                    _mt_animate = true;
                    $menuLi.addClass("reset");
                }, 300);
            } else {
                $self.addClass("active");
                $menuOverlay.addClass("active");
                $menuOverlay.css({
                    height: $menuOverlayInner.height() + 1,
                });
                true;
                setTimeout(function () {
                    _mt_animate = true;
                    $menuLi.addClass("reset");
                }, 600);
            }
        }
    });

    $faq.on("click", function (eve) {
        if (eve.target.tagName.toUpperCase() !== "A") {
            var $self = $(eve.currentTarget);

            if ($self.hasClass("open")) {
                $self.removeClass("open");
            } else {
                $self.addClass("open");
            }
        }
    });

    $window.on("scroll", function () {
        var currentPos = $window.scrollTop();
        var height = windowH;
        _startPos = currentPos;

        $section.each(function () {
            if (!_animate) {
                return;
            } else {
                var $self = $(this);
                var elemPos = $self.offset().top;
                var scroll = $window.scrollTop();
                if (scroll > elemPos && scroll < elemPos + $self.height()) {
                    $scrollTrigger.removeClass("active");
                    $("." + $self.attr("id") + "-menu").addClass("active");
                }
            }
        });
        if (windowW < 640) {
            height = windowH / 2;
        }
        if (currentPos > _startPos && currentPos > height) {
            $goToTop.addClass("active");
        } else {
            $goToTop.removeClass("active");
        }
        $tabWrapper.addClass("active");

        if ($productNavigationBack.length != 0) {
            $productNavigationBack.css("height", currentPos);
        }

        if (parallax.length != 0) {
            parallaxFunc();
        }

        initialAnimation();
    });

    $(document).on("touchmove", function (e) {
        var currentY = e.originalEvent.touches[0].clientY;
        if (currentY < _lastY) {
            $goToTop.addClass("active");
        } else {
            $goToTop.removeClass("active");
        }
        _lastY = currentY;
    });

    $window
        .on("resize", function () {
            windowW = window.innerWidth;
            windowH = window.innerHeight;

            if (windowW < 768) {
                $menuOverlayInner.css({
                    height:
                        windowH -
                        $header.height() -
                        $(".mp-bar-inner").height(),
                });
            }

            if (_initial) {
                _initial = false;

                //$('html, body').animate({scrollTop: 0}, 100);
                $body.addClass("loaded");
                $keyv.eq(0).addClass("active");
                initialAnimation();
                _topSlider = setInterval(slide, 11000);
                _originalSlider = setInterval(originalSlide, 2500);

                $uaCart.filter(".active").css("visibility", "visible");

                if (window.location.href.match(/contact/)) {
                    $("textarea").val("");
                }
            }
        })
        .resize();
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
    var selectors = {
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productFeaturedImage: "[data-product-featured-image]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        productThumbs: "[data-product-single-thumbnail]",
        singleOptionSelector: "[data-single-option-selector]",
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr("data-section-id");
        this.productSingleObject = JSON.parse(
            $(selectors.productJson, this.$container).html()
        );

        var options = {
            $container: this.$container,
            enableHistoryState:
                this.$container.data("enable-history-state") || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject,
        };

        this.settings = {};
        this.namespace = ".product";
        this.variants = new slate.Variants(options);
        window.variants = this.variants;
        this.$featuredImage = $(
            selectors.productFeaturedImage,
            this.$container
        );

        this.$container.on(
            "variantChange" + this.namespace,
            this.updateAddToCartState.bind(this)
        );
        this.$container.on(
            "variantPriceChange" + this.namespace,
            this.updateProductPrices.bind(this)
        );

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(
                this.$featuredImage.attr("src")
            );
            slate.Image.preload(
                this.productSingleObject.images,
                this.settings.imageSize
            );

            this.$container.on(
                "variantImageChange" + this.namespace,
                this.updateProductImage.bind(this)
            );
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {
        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass("hide");
            } else {
                $(selectors.addToCart, this.$container).prop("disabled", true);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.unavailable
                );
                $(selectors.priceWrapper, this.$container).addClass("hide");
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop("disabled", false);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.addToCart
                );
            } else {
                $(selectors.addToCart, this.$container).prop("disabled", true);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.soldOut
                );
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container
            );

            $(selectors.productPrice, this.$container).html(
                slate.Currency.formatMoney(variant.price, theme.moneyFormat)
            );

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    slate.Currency.formatMoney(
                        variant.compare_at_price,
                        theme.moneyFormat
                    )
                );
                $compareEls.removeClass("hide");
            } else {
                $comparePrice.html("");
                $compareEls.addClass("hide");
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(
                variant.featured_image.src,
                this.settings.imageSize
            );

            this.$featuredImage.attr("src", sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        },
    });

    return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector(
            "AddressCountryNew",
            "AddressProvinceNew",
            {
                hideElement: "AddressProvinceContainerNew",
            }
        );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
        var formId = $(this).data("form-id");
        var countrySelector = "AddressCountry_" + formId;
        var provinceSelector = "AddressProvince_" + formId;
        var containerSelector = "AddressProvinceContainer_" + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector,
        });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
        $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function () {
        var formId = $(this).data("form-id");
        $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function () {
        var $el = $(this);
        var formId = $el.data("form-id");
        var confirmMessage = $el.data("confirm-message");
        if (
            confirm(
                confirmMessage ||
                    "Are you sure you wish to delete this address?"
            )
        ) {
            Shopify.postLink("/account/addresses/" + formId, {
                parameters: { _method: "delete" },
            });
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
    var config = {
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink",
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === "#recover") {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $("#RecoverPasswordForm").toggleClass("hide");
        $("#CustomerLoginForm").toggleClass("hide");
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $(".reset-password-success");

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $("#ResetSuccess").removeClass("hide");
    }
})();

$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register("product", theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = ".rte table";

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: "rte__table-wrapper",
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: "rte__video-wrapper",
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace(
            "supports-no-cookies",
            "supports-cookies"
        );
    }
});
(function () {
    var baseBack = [
        "https://cdn.shopify.com/s/files/1/2791/5352/files/images01.png?v=1601886208",
        "https://cdn.shopify.com/s/files/1/2791/5352/files/images03_2x_d6840ec8-58ab-48e2-8fe6-d3a8b4a99d61.png?v=1601976206",
        "https://cdn.shopify.com/s/files/1/2791/5352/files/images04_2x_ef568315-8a33-4ee6-a2f0-7943b0bd790a.png?v=1601976211",
        "https://cdn.shopify.com/s/files/1/2791/5352/files/images02_2x_09b6abc6-29d7-4997-93a9-63508aa50936.png?v=1601976212",
        "https://cdn.shopify.com/s/files/1/2791/5352/files/images05_2x_7ea5689d-5cd1-421d-b4dc-297bd887f104.png?v=1601976213",
    ];
    if (typeof window._popIn_engagement_backimage !== "undefined") {
        baseBack = window._popIn_engagement_backimage;
    }
    var baseImageUrl = baseBack[Math.ceil(Math.random() * baseBack.length - 1)];

    // engagement script
    var styleText =
        '\
.engagement-wrapper {\
        padding: 0px;\
        position: fixed;\
        width: 500px;\
        height: 0vh;\
        bottom: -10px;\
        left: calc( 50vw - 300px );\
        background: url("' +
        baseImageUrl +
        '");\
        background-size: cover;\
        background-position: center center;\
        transition: 0.3s height ease;\
        z-index: 99998;\
}\
.engagement-wrapper.show {\
        height: 100vh;\
        cursor: pointer;\
}\
.engagement-wrapper.small.show {\
        // background-image: url("https://cdn.shopify.com/s/files/1/2791/5352/files/20210103_mail_popup.jpg?v=1609676263");\
        background-image: initial;\
        background-size: contain;\
        background-repeat: no-repeat;\
        background-position: top;\
        background-color: #333;\
        height: 480px;\
        bottom: -430px;\
        left: 50%;\
        transform: translate(-50%,-50%);\
        border-top: 1px solid #333;\
}\
.engagement-wrapper img.engagement-close {\
        position: absolute;\
        top: 20px;\
        right: 20px;\
        width: 20px;\
        height: 20px;\
        cursor: pointer;\
        z-index: 99999;\
}\
.engagement-wrapper img.engagement-text{\
    position: absolute;\
    top: 30%;\
    right: 20px;\
    width: calc(100% - 40px);\
    height: auto;\
    cursor: pointer;\
    z-index: 99999;\
}\
.engagement-wrapper .engagement-black {\
        position: absolute;\
        // top: 67%;\
        top: 30%;\
        left: 50%;\
        transform: translateY(-50%) translateX(-50%);\
        background: rgba( 172, 20, 35, 0.5);\
        display: none;\
        width: calc( 100vw - 20px );\
        max-width: 500px;\
}\
.aladdin_mail .engagement-black {\
        background: rgba( 0, 0, 0, 0.5);\
        width: calc( 100vw - 20px );\
        max-width: 500px;\
        margin: 0px auto;\
        padding: 10px;\
}\
.engagement-wrapper.small .engagement-black {\
        background: transparent;\
}\
.engagement-wrapper.show .engagement-black {\
        display: block;\
}\
.engagement-message {\
        font-size: 16px;\
        text-align: center;\
        line-height: 1.5;\
        color: #fff;\
        margin: 0 0 1em 0;\
        display: flex;\
        justify-content: center;\
        flex-direction: row;\
}\
.engagement-message .engagement-coupon {\
    width: 250px;\
    margin-top: 12px;\
}\
.engagement-black form {\
    width: 100%;\
    margin-bottom: 20px;\
}\
.engagement-black form input[type=mail] {\
        height: 44px;\
        width: calc( 100% - 100px );\
        margin: 0px auto;\
        padding-left: 15px;\
        font-size: 16px;\
        display: block;\
        border: none;\
        outline: 0;\
}\
.engagement-black form input[type=submit] {\
        width: calc( 100% - 100px ) !important;\
        margin: 10px auto;\
        height: 40px !important;\
        font-size: 16px;\
        -webkit-appearance: button;\
        appearance: button;\
}\
.engagement-black form input[type=submit]:disabled {\
    background: #ccc;\
}\
.engagement-black form input[type="submit"]::-webkit-search-decoration{\
  display: none;\
}\
.engagement-black form input[type="submit"]::focus{\
  outline-offset: -2px;\
}\
.engagement-black .big-screen-life{\
  font-size:20px;\
  color: #eeba26;\
}\
.engagement-black .engagement-message .message-badge {\
    display: flex;\
    flex-direction: column;\
     justify-content: center;\
     align-items: center;\
}\
.engagement-black .engagement-message .message-text {\
}\
.engagement-black .engagement-message img.badge {\
        width: 160px;\
    margin-right:20px;\
}\
@media screen and (max-width: 768px) {\
.engagement-wrapper.show {\
        left: -8px;\
        height: 70vh !important;\
        width: calc( 100vw + 16px );\
        cursor: pointer;\
}\
.engagement-wrapper.small.show {\
    height: 120vw !important;\
    bottom: -120vw !important;\
    width: 100%\
}\
.engagement-black .engagement-message {\
flex-direction: column;\
margin: 0;\
}\
.engagement-black .engagement-message .message-badge{\
    margin-bottom: 20px;\
}\
.engagement-black .engagement-message img.badge {\
    position: absolute;\
    top: -50px;\
    width: 200px;\
    margin-right:0px;\
}\
.engagement-wrapper img.engagement-text {\
    top: 37%;\
}\
.engagement-wrapper .engagement-black {\
    // top: 60%;\
    top: 26%;\
}\
.engagement-black form input[type=mail] {\
    width: calc(100% - 40px);\
}\
.engagement-black form input[type=submit] {\
    width: calc(100% - 40px) !important;\
}\
}\
';

    window._popIn_engagement_small = true;

    var checkTimer = null;
    var scrollCheck = function () {
        if (window.pageYOffset > 300) {
            var wrapper = document.querySelector(".engagement-wrapper");
            wrapper.classList.add("show");
            if (
                typeof window._popIn_engagement_small !== "undefined" &&
                window._popIn_engagement_small
            ) {
                wrapper.classList.add("small");
            }
            clearInterval(checkTimer);
        }
    };

    var closeEngagement = function (eve) {
        var targetClass = eve.target.className;
        if (/engagement-close|engagement-wrapper/.test(targetClass)) {
            eve.preventDefault();
            var engagementWrppaer = document.querySelector(
                ".engagement-wrapper"
            );
            if (engagementWrppaer) {
                document.body.removeChild(engagementWrppaer);
            }
            window.sessionStorage.setItem("engagement_close", 1);
        }
    };

    var submitForm = async function (eve) {
        eve.preventDefault();
        var submit = eve.target.querySelector(".engagement-submit");
        submit.disabled = true;
        try {
            var postData = {};
            postData.email = eve.target.querySelector(".engagement-mail").value;
            postData.tag = "mittunonegai_1119";
            var response = await fetch(
                "https://aladdin-api-jp.xgimi.com/aladdin/api/mailchimp/pa2_register",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    mode: "cors",
                    body: JSON.stringify(postData),
                }
            );

            // console.log(response); //debug

            var isSuccess = response.status === 200;
            if (!isSuccess) {
                submit.disabled = false;
                console.error("通信に失敗しました");
            } else {
                window.localStorage.setItem("engagement_success", Date.now());
                window.sessionStorage.setItem("engagement_close", 1);
                var form = eve.target;
                form.style.display = "none";

                var engagementMessage = eve.target.parentNode.querySelector(
                    ".engagement-message"
                );
                engagementMessage.innerHTML =
                    "登録ありがとうございます。<br>メールをご確認ください。";
                /*
                gtag("event", "click", {
                    event_category: "magmag",
                    event_label: "touroku",
                    value: "0",
                });
*/

                // ga('send', 'event', 'click', 'magmag', 'touroku',"0");
                dataLayer.push({ event: "mag_touroku" });
            }
            return false;
        } catch (error) {
            console.error(error);
        }
    };
    var engagement = function () {
        // set style
        var css = document.createElement("style");
        css.appendChild(document.createTextNode(styleText));
        document.getElementsByTagName("head")[0].appendChild(css);

        // settings
        var engagementHTML =
            //"<div class='big-screen-life'>✨楽天お買い物マラソン✨</div>";
            "<div class='message-badge'><div class='message-text'><div class='big-screen-life'>✨楽天お買い物マラソン✨</div>12,000円OFFクーポンを配布中<br>↓メール登録でクーポンを取得する↓</div>";
        //"7万人の購入者が<br>popIn Aladdinを選んだ理由を限定公開<br><img src='https://cdn.shopify.com/s/files/1/2791/5352/files/title-coupon.svg?v=1601974733' alt='coupon' class='engagement-coupon'>";
        if (typeof window._popIn_engagement_message !== "undefined") {
            engagementHTML = window._popIn_engagement_message;
        }

        // check local storage
        var _popIn_engagement_success = window.localStorage.getItem(
            "engagement_success"
        );

        // check aladdin_mail div
        var checkNodes = document.querySelectorAll(".aladdin_mail");

        // console.log(_popIn_engagement_success);//debug
        if (_popIn_engagement_success && checkNodes.length === 0) {
            return;
        }

        _popIn_engagement_success = window.sessionStorage.getItem(
            "engagement_close"
        );
        // console.log(_popIn_engagement_success);//debug
        if (_popIn_engagement_success && checkNodes.length === 0) {
            return;
        }

        var engagementWrppaer = document.createElement("div");
        engagementWrppaer.classList.add("engagement-wrapper");
        engagementWrppaer.addEventListener("click", closeEngagement, false);

        var icon = engagementWrppaer.appendChild(document.createElement("img"));
        icon.src =
            "https://cdn.shopify.com/s/files/1/2791/5352/files/20201119_mail_modal_close.png?v=1605772181";
        icon.addEventListener("click", closeEngagement, false);
        icon.classList.add("engagement-close");

        var img_text = engagementWrppaer.appendChild(
            document.createElement("img")
        );
        // img_text.src =
        //     "https://cdn.shopify.com/s/files/1/2791/5352/files/20201119_mail_modal_text.png?v=1605772181";
        // img_text.classList.add("engagement-text");

        var engagementBlack = engagementWrppaer.appendChild(
            document.createElement("div")
        );
        engagementBlack.classList.add("engagement-black");

        var engagementMessage = engagementBlack.appendChild(
            document.createElement("div")
        );
        engagementMessage.classList.add("engagement-message");
        engagementMessage.innerHTML = engagementHTML;

        var engagementForm = engagementBlack.appendChild(
            document.createElement("form")
        );
        engagementForm.addEventListener("submit", submitForm, false);

        var engagementMail = engagementForm.appendChild(
            document.createElement("input")
        );
        engagementMail.type = "mail";
        engagementMail.classList.add("engagement-mail");
        engagementMail.placeholder = "メールアドレスを登録してください";

        var engagementSubmit = engagementForm.appendChild(
            document.createElement("input")
        );
        engagementSubmit.value = "送信";
        engagementSubmit.type = "submit";
        engagementSubmit.classList.add("btn-common", "engagement-submit");

        if (checkNodes.length == 0) {
            document.body.appendChild(engagementWrppaer);

            checkTimer = setInterval(scrollCheck, 3000);
        } else {
            for (var i = 0, iz = checkNodes.length; i < iz; i++) {
                checkNodes[i].appendChild(engagementBlack.cloneNode(true));
                checkNodes[i]
                    .querySelector("form")
                    .addEventListener("submit", submitForm, false);
            }
        }
    };
    if (typeof window._popIn_engagement_exclude !== "undefined") {
        var reg = new RegExp(window._popIn_engagement_exclude);
        if (reg.test(location.href)) {
            return;
        }
    }

    // set exclude url
    //
    if (
        /\/products\/|pages\/support|enjoyhome-tour|\/cart|help|for-partner|2years-secret-sale|GIGAZINE-present202010|orico|rakuten_2nd_anniversary|magic-in-the-air|enjoy-home|aladdin_mail|present/.test(
            location.href
        )
    ) {
        return;
    }
    //engagement();
})();
// (function () {
//     // NEW POPIN ACTION CODE
//     if (
//         !window.localStorage ||
//         (typeof window._popIn_action_ignore !== "undefined" &&
//             window._popIn_action_ignore)
//     ) {
//         return;
//     }

//     // initialize
//     var KEY_NAME = "popIn_action_data";
//     var action_data = {
//         all: {
//             starttime: 0,
//             lasttime: 0,
//             readtime: 0,
//             sessioncount: 0,
//         },
//         pages: {},
//     };

//     if (window.localStorage.getItem("popIn_action_data")) {
//         action_data = JSON.parse(window.localStorage.getItem(KEY_NAME));
//     }

//     var canonicalNode = document.querySelector("link[rel=canonical]");
//     var url = canonicalNode
//         ? canonicalNode.getAttribute("href")
//         : window.location.href;

//     if (typeof action_data.pages[url] === "undefined") {
//         action_data.pages[url] = {
//             sessioncount: 1,
//             starttime: Date.now(),
//             lasttime: Date.now(),
//             readtime: 0,
//         };
//     } else {
//         action_data.pages[url].sessioncount += 1;
//         action_data.pages[url].lasttime = Date.now();
//     }

//     var total_readtime = 0;
//     var total_sessioncount = 0;
//     var all_starttime = Date.now();
//     var all_lasttime = 0;
//     for (var key in action_data.pages) {
//         var page = action_data.pages[key];

//         total_sessioncount += page.sessioncount;
//         total_readtime += page.readtime;
//         if (all_starttime > page.starttime) {
//             all_starttime = page.starttime;
//         }
//         if (all_lasttime < page.lasttime) {
//             all_lasttime = page.lasttime;
//         }
//     }

//     action_data.all.starttime = all_starttime;
//     action_data.all.lasttime = all_lasttime;
//     action_data.all.readtime = total_readtime;
//     action_data.all.sessioncount = total_sessioncount;

//     window.localStorage.setItem(KEY_NAME, JSON.stringify(action_data));
//     //console.error(action_data);

//     var updateReadTimer = function () {
//         if (
//             typeof PopIn5 === "undefined" ||
//             typeof PopIn5.Read === "undefined" ||
//             typeof PopIn5.Read._instance === "undefined" ||
//             typeof PopIn5.Read._instance.readInstances === "undefined"
//         ) {
//             return;
//         }

//         // initialize
//         var KEY_NAME = "popIn_action_data";
//         var action_data = {
//             all: {
//                 starttime: 0,
//                 lasttime: 0,
//                 readtime: 0,
//                 sessioncount: 0,
//             },
//             pages: {},
//         };

//         if (window.localStorage.getItem("popIn_action_data")) {
//             action_data = JSON.parse(window.localStorage.getItem(KEY_NAME));
//         }

//         var canonicalNode = document.querySelector("link[rel=canonical]");
//         var url = canonicalNode
//             ? canonicalNode.getAttribute("href")
//             : window.location.href;

//         var last_session_data = action_data.pages[url];

//         // update last session data
//         var readTime = Math.floor(
//             PopIn5.Read._instance.readInstances[0].data.totalViewTime
//         );
//         last_session_data.readtime += readTime;

//         window.localStorage.setItem(KEY_NAME, JSON.stringify(action_data));
//     };

//     // update readtime
//     setInterval(updateReadTimer, 1000);
// })();
/*
(function () {
    var _privyTimer = null;
    var _privyCounter = 0;
    var isScopeTime = function () {
        var hour = new Date().getHours();
        if (hour === 20 || true) {
            return true;
        }
        return false;
    };
    var watchPrivy = function () {
        var watchSelector =
            ".privy-element-wrapper.privy-button-element-wrapper.privy-element-wrapper-absolute";
        var element = document.querySelector(watchSelector);
        // if (element ) { //debug code
        if (element && isScopeTime()) {
            var baseElement = document.querySelector(
                ".privy-popup-content.privy-foreground-element"
            );
            var bHeight = baseElement.style.height.replace("px", "");
            baseElement.style.height = +bHeight + 45 + "px";

            var div = document.createElement("div");
            div.style.zIndex = 4;
            div.style.top = "475px";
            div.style.left = "25px";
            div.style.width = "300px";
            div.style.height = "45px";
            div.style.position = "absolute";

            var button = div.appendChild(document.createElement("button"));
            button.setAttribute(
                "data-link",
                "https://aladdin.popin.cc/pages/amperstand-live-shopping"
            );

            button.style.color = "#000";
            button.style.fontFamily = 'Lato, Helvetica, Arial, "Sans Serif"';
            button.style.fontSize = "20px";
            button.style.fontWeight = 400;
            button.style.textAlign = "center";
            button.style.letterSpacing = "0px";
            button.style.backgroundColor = "rgb(238, 186, 38)";
            button.style.borderWidth = "0px";
            button.style.borderRadius = "40px";
            button.style.width = "100%";
            button.style.height = "100%";

            button.appendChild(document.createTextNode("購入前のお悩み相談はこちら"));
            button.addEventListener(
                "click",
                function () {
                    ga('send', 'event', 'LIVE', 'CLICK', 'pm21');
                    window.top.location =
                        "https://aladdin.popin.cc/pages/amperstand-live-shopping";
                },
                false
            );
            element.parentNode.appendChild(div);
            clearInterval(_privyTimer);
        }
        _privyCounter++;
        // fallback code, wait 1minutes.
        if (_privyCounter > 60) {
            console.error("privy counter stop");
            clearInterval(_privyTimer);
        }
    };
    _privyTimer = setInterval(watchPrivy, 1000);
})();
*/
// (function () {
//     var _baseStyle =
//         "\
//         .twinkleWrapper{\
//             background-size :cover;\
//             background-repeat :no-repeat;\
//             background-position : center center;\
//             width :100px;\
//             height :100px;\
//             position :fixed;\
//             bottom :110px;\
//             transition : opacity 1s;\
//         }\
//         .twinkleHide {\
//             opacity: 0;\
//         }\
//     ";
//     var style = document.createElement("style");
//     style.appendChild(document.createTextNode(_baseStyle));

//     document.getElementsByTagName("head")[0].appendChild(style);

//     var waitCounter = 0,
//         waitTimer = null;

//     //Add Image
//     var images = [
//         "https://cdn.shopify.com/s/files/1/2791/5352/files/00.png?v=1627387497",
//         "https://cdn.shopify.com/s/files/1/2791/5352/files/01_ccb0d163-518a-4868-93a0-5bee812d30ea.png?v=1627387509",
//     ];
//     // cache
//     new Image().src = images[0];
//     new Image().src = images[1];

//     var twinkle = function () {
//         var twinkle1 = document.getElementById("popin-twinkle1");
//         var twinkle2 = document.getElementById("popin-twinkle2");
//         if (twinkle1.classList.contains("twinkleHide")) {
//             twinkle1.classList.remove("twinkleHide");
//             twinkle2.classList.add("twinkleHide");
//         } else {
//             twinkle2.classList.remove("twinkleHide");
//             twinkle1.classList.add("twinkleHide");
//         }
//     };

//     var waitButton = function () {
//         var node = document.querySelector(
//             ".reset-box .widget-container .live-btn"
//         );
//         if (node) {
//             var topNode = node.parentNode.parentNode.parentNode;

//             var newNode = topNode.appendChild(document.createElement("div"));
//             newNode.id = "popin-twinkle1";
//             newNode.classList.add("twinkleWrapper");
//             newNode.style.backgroundImage = "url(" + images[0] + ")";

//             var newNode2 = topNode.appendChild(document.createElement("div"));
//             newNode2.id = "popin-twinkle2";
//             newNode2.classList.add("twinkleWrapper", "twinkleHide");
//             newNode2.style.backgroundImage = "url(" + images[1] + ")";

//             window.clearInterval(waitTimer);
//             window.setInterval(twinkle, 1000);
//         }
//         if (waitCounter > 120) {
//             window.clearInterval(waitTimer);
//         }
//         waitCounter++;
//     };
//     waitTimer = window.setInterval(waitButton, 1000);
// })();
